import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { openNotificationTarget } from './notificationRouter';
import { Platform, View, StyleSheet, Text, TouchableOpacity, Linking, BackHandler } from 'react-native';
import { InsetModal as Modal } from '../components/InsetModal';
import { NativePhoneCallModal } from '../components/NativePhoneCallModal';
import { Ionicons } from '@expo/vector-icons';
import { FEATURE_FLAGS } from '../config/api.config';
import { decodeBase64Url } from '../utils/token-utils';
import { WelcomeScreen } from '../screens/WelcomeScreen';
import { LoginScreen } from '../screens/LoginScreen';
import { UnifiedLoginScreen } from '../screens/UnifiedLoginScreen';
import { BusinessPickerScreen } from '../screens/BusinessPickerScreen';
import { BusinessCreationWizardScreen } from '../screens/BusinessCreationWizardScreen';
import { PlanSelectionScreen } from '../screens/PlanSelectionScreen';
import { BillingScreen } from '../screens/BillingScreen';
import { BillingReturnScreen } from '../screens/BillingReturnScreen';
import { BillingAddonsScreen } from '../screens/BillingAddonsScreen';
import { setBusinessLockedHandler } from '../services/api';
import { ChannelOnboardingStepper } from '../screens/ChannelOnboardingStepper';
import { RegisterScreen } from '../screens/RegisterScreen';
import { OTPVerificationScreen } from '../screens/OTPVerificationScreen';
import { ForgotPasswordScreen } from '../screens/ForgotPasswordScreen';
import { ResetPasswordScreen } from '../screens/ResetPasswordScreen';
import { BusinessSetupScreen } from '../screens/BusinessSetupScreen';
import { HomeScreen } from '../screens/HomeScreen';
import { DashboardScreen } from '../screens/DashboardScreen';
import { DashboardTeamAllScreen } from '../screens/dashboard/DashboardTeamAllScreen';
import { DashboardTemplatesAllScreen } from '../screens/dashboard/DashboardTemplatesAllScreen';
import { PostsListScreen } from '../screens/PostsListScreen';
import { PostCreateScreen } from '../screens/PostCreateScreen';
import { DashboardFlowsAllScreen } from '../screens/dashboard/DashboardFlowsAllScreen';
import { DashboardAssignmentsAllScreen } from '../screens/dashboard/DashboardAssignmentsAllScreen';
import { SocialHubScreen } from '../screens/SocialHubScreen';
import { ReportsScreen } from '../screens/ReportsScreen';
import { WhatsAppTestScreen } from '../screens/WhatsAppTestScreen';
import { WhatsAppBusinessSetupScreen } from '../screens/WhatsAppBusinessSetupScreen';
import { WhatsAppContactScreen } from '../screens/WhatsAppContactScreen';
import { ContactsListScreen } from '../screens/ContactsListScreen';
import { NotificationHistoryScreen } from '../screens/NotificationHistoryScreen';
import { FacebookMessengerSetupScreen } from '../screens/FacebookMessengerSetupScreen';
import { FacebookCallbackScreen } from '../screens/FacebookCallbackScreen';
import { XTwitterSetupScreen } from '../screens/XTwitterSetupScreen';
import { PhoneSetupScreen } from '../screens/PhoneSetupScreen';
import { AiSetupScreen } from '../screens/AiSetupScreen';
import { AiUsageScreen } from '../screens/AiUsageScreen';
import { VisitsSetupScreen } from '../screens/VisitsSetupScreen';
import { VisitsListScreen } from '../screens/VisitsListScreen';
import { VisitDetailScreen } from '../screens/VisitDetailScreen';
import { VisitCreateScreen } from '../screens/VisitCreateScreen';
import { VisitExecuteScreen } from '../screens/VisitExecuteScreen';
import { VisitRouteScreen } from '../screens/VisitRouteScreen';
import { VisitCampaignsListScreen } from '../screens/VisitCampaignsListScreen';
import { VisitCampaignCreateScreen } from '../screens/VisitCampaignCreateScreen';
import { VisitCampaignDetailScreen } from '../screens/VisitCampaignDetailScreen';
import { VisitCampaignDistributeScreen } from '../screens/VisitCampaignDistributeScreen';
import { CallHistoryScreen } from '../screens/CallHistoryScreen';
import { ChatScreen } from '../screens/ChatScreen';
import { InboxScreen } from '../screens/InboxScreen';
import { ConversationScreen } from '../screens/ConversationScreen';
import { SubscriptionScreen } from '../screens/SubscriptionScreen';
import { UserSetupScreen } from '../screens/UserSetupScreen';
import { DepartmentsScreen } from '../screens/DepartmentsScreen';
import { BusinessPermissionsScreen } from '../screens/BusinessPermissionsScreen';
import { AddVerifyIdentityScreen } from '../screens/AddVerifyIdentityScreen';
import { AddDepartmentScreen } from '../screens/AddDepartmentScreen';
import { InvitationAcceptanceScreen } from '../screens/InvitationAcceptanceScreen';
import { PaymentScreen } from '../screens/PaymentScreen';
import { BulkContactUploadScreen } from '../screens/BulkContactUploadScreen';
import { SendWhatsAppMessageScreen } from '../screens/SendWhatsAppMessageScreen';
import { TaskHistoryScreen } from '../screens/TaskHistoryScreen';
import { SettingsScreen } from '../screens/SettingsScreen';
import { ProductsListScreen } from '../screens/ProductsListScreen';
import { GlobalSearchHost } from '../components/search/GlobalSearchHost';
import { ProductDetailScreen } from '../screens/ProductDetailScreen';
import { DataListsScreen } from '../screens/DataListsScreen';
import { LeadFinderScreen } from '../screens/LeadFinderScreen';
import { LeadRunScreen } from '../screens/LeadRunScreen';
import { AssignmentRulesScreen } from '../screens/AssignmentRulesScreen';
import { AssignmentRuleEditScreen } from '../screens/AssignmentRuleEditScreen';
import { DataListSchemaScreen } from '../screens/DataListSchemaScreen';
import { DataListRecordsScreen } from '../screens/DataListRecordsScreen';
import { DataListRecordFormScreen } from '../screens/DataListRecordFormScreen';
import { ProductCreateScreen } from '../screens/ProductCreateScreen';
import { ProductEditScreen } from '../screens/ProductEditScreen';
import { AddProductScreen } from '../screens/AddProductScreen';
import { BulkImportScreen } from '../screens/BulkImportScreen';
import { AddOrderScreen } from '../screens/AddOrderScreen';
import { CataloguesListScreen } from '../screens/CataloguesListScreen';
import { CatalogueDetailScreen } from '../screens/CatalogueDetailScreen';
import { CatalogueCreateScreen } from '../screens/CatalogueCreateScreen';
import { VendorsListScreen } from '../screens/VendorsListScreen';
import { VendorFormScreen } from '../screens/VendorFormScreen';
import { VendorDetailScreen } from '../screens/VendorDetailScreen';
import { VendorAddProductsScreen } from '../screens/VendorAddProductsScreen';
import { VendorBulkUploadScreen } from '../screens/VendorBulkUploadScreen';
import { QuotationsListScreen } from '../screens/QuotationsListScreen';
import { QuotationFormScreen } from '../screens/QuotationFormScreen';
import { QuotationDetailScreen } from '../screens/QuotationDetailScreen';
import { QuotationTemplatesListScreen } from '../screens/QuotationTemplatesListScreen';
import { QuotationTemplateEditorScreen } from '../screens/QuotationTemplateEditorScreen';
import { ContactCreateScreen } from '../screens/ContactCreateScreen';
import { CatalogueEditScreen } from '../screens/CatalogueEditScreen';
import { AddProductsToCatalogueScreen } from '../screens/AddProductsToCatalogueScreen';
import { ManageCatalogueChannelsScreen } from '../screens/ManageCatalogueChannelsScreen';
import { QuickRepliesListScreen } from '../screens/QuickRepliesListScreen';
import { QuickReplyItemsListScreen } from '../screens/QuickReplyItemsListScreen';
import { QuickReplySetCreateScreen } from '../screens/QuickReplySetCreateScreen';
import { QuickReplySetEditScreen } from '../screens/QuickReplySetEditScreen';
import { QuickReplySetItemsScreen } from '../screens/QuickReplySetItemsScreen';
import { QuickReplyItemCreateScreen } from '../screens/QuickReplyItemCreateScreen';
import { QuickReplyItemEditScreen } from '../screens/QuickReplyItemEditScreen';
import { DispatchRulesListScreen } from '../screens/DispatchRulesListScreen';
import { DispatchRuleEditScreen } from '../screens/DispatchRuleEditScreen';
import { FlowsListScreen } from '../screens/FlowsListScreen';
import { FlowEditScreen } from '../screens/FlowEditScreen';
import { CalendarListScreen } from '../screens/CalendarListScreen';
import { CalendarCreateScreen } from '../screens/CalendarCreateScreen';
import { CalendarEditScreen } from '../screens/CalendarEditScreen';
import { CalendarBookingScreen } from '../screens/CalendarBookingScreen';
import { ProductScannerScreen } from '../screens/ProductScannerScreen';
import { DevicesListScreen } from '../screens/DevicesListScreen';
import { DeviceCreateScreen } from '../screens/DeviceCreateScreen';
import { DeviceEditScreen } from '../screens/DeviceEditScreen';
import { UnitsListScreen } from '../screens/UnitsListScreen';
import { ShippingMethodsScreen } from '../screens/ShippingMethodsScreen';
import { ShippingMethodFormScreen } from '../screens/ShippingMethodFormScreen';
import { CatalogViewScreen } from '../screens/CatalogViewScreen';
import { CartScreen } from '../screens/CartScreen';
import { CheckoutScreen } from '../screens/CheckoutScreen';
import { OrderSuccessScreen } from '../screens/OrderSuccessScreen';
import { OrdersScreen } from '../screens/OrdersScreen';
import { InventoryScreen } from '../screens/InventoryScreen';
import { BusinessConfigScreen } from '../screens/BusinessConfigScreen';
import { BusinessProfileScreen } from '../screens/BusinessProfileScreen';
import { CouponsScreen } from '../screens/CouponsScreen';
import { TemplateManagementScreen } from '../screens/TemplateManagementScreen';
import { ReferralsScreen } from '../screens/ReferralsScreen';
import { TrackOrderScreen } from '../screens/TrackOrderScreen';
import { BusinessCalendarScreen } from '../screens/BusinessCalendarScreen';
import { EventListScreen } from '../screens/EventListScreen';
import { EventCreateScreen } from '../screens/EventCreateScreen';
import { EventEditScreen } from '../screens/EventEditScreen';
import { EventDetailScreen } from '../screens/EventDetailScreen';
import { Notification } from '../components/Notification';
import { PhoneCallScreen } from '../components/PhoneCallScreen';
import { PhoneCallMinimizedBar } from '../components/PhoneCallMinimizedBar';
import { apiService, syncApiServiceWithStore } from '../services/api';
import { useAppStore, Business } from '../store/appStore';
import { usePhoneDialer } from '../hooks/usePhoneDialer';
import { useIsMobileBrowser } from '../hooks/useIsMobileBrowser';
import { useDesktopPaneLayout } from '../hooks/useDesktopPaneLayout';
import { PersistentPaneShell } from '../components/PersistentPaneShell';
import { useChatStore } from '../store/chatStore';
import { useCalendarReminderStore } from '../store/calendarReminderStore';
import { notificationService } from '../services/notification.service';
import { socketService } from '../services/socket.service';
import { fcmService } from '../services/fcm.service';
import { AppContext, AppContextType, Screen } from '../contexts/AppContext';

// Web routing configuration
import { getScreenFromPath, getPathFromScreen } from './web-routes';
import { isPreAuthOnlyScreen, isAuthRequiredScreen } from './navigation-guards';
import { parseAppLink, APP_LINK_ID_KEYS } from './app-links';
import { getRegisteredBackAction } from './hardwareBack';

export const AppNavigator: React.FC = () => {
  console.log('🔍 [AppNavigator] Initializing...');
  
  const [currentScreen, setCurrentScreen] = useState<Screen>('welcome');
  // Native calling opens the call screen in an in-app WebView modal rather
  // than an external browser tab (expo-web-browser's openBrowserAsync) —
  // the URL it should load, or null when closed. Dismissed either by this
  // app's own close button (rendered by renderMobileCallOverlay below) or
  // by CallScreen.tsx's OWN dismiss button posting a message back through
  // the WebView bridge (see the WebView's onMessage handler) — the same
  // two-way postMessage pattern LiveVisitMap.tsx already uses for its map.
  const [nativeCallModalUrl, setNativeCallModalUrl] = useState<string | null>(null);
  // popstate's listener below is registered once (mount-only effect) so it can't close over a
  // fresh `currentScreen` on every render — without this ref it compares screenFromUrl.screen
  // against whatever `currentScreen` was AT MOUNT TIME forever, so browser back/forward can
  // silently no-op (URL changes, setCurrentScreen never fires) whenever that stale value
  // happens to match the destination screen.
  const currentScreenRef = useRef(currentScreen);
  currentScreenRef.current = currentScreen;
  const [notification, setNotification] = useState<{
    visible: boolean;
    type: 'success' | 'error' | 'info' | 'warning' | 'message';
    title: string;
    message: string;
    action?: { label: string; onPress: () => void; channel?: string; channelName?: string; data?: Record<string, any> };
  }>({
    visible: false,
    type: 'success',
    title: '',
    message: '',
  });

  const [activeTab, setActiveTab] = useState<string>(() => {
    // Initialize activeTab based on URL for web to avoid flash
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      // Check if using hash routing
      const hash = window.location.hash;
      const path = hash ? hash.substring(1) : window.location.pathname; // Remove '#' from hash
      const screenFromUrl = getScreenFromPath(path);
      console.log('🟡 [AppNavigator] Initializing activeTab from URL:', { hash, pathname: window.location.pathname, finalPath: path, screen: screenFromUrl.screen });
      if (screenFromUrl.screen === 'business-calendar') {
        console.log('🟡 [AppNavigator] Setting initial activeTab to: calendar');
        return 'calendar';
      }
      if (screenFromUrl.screen === 'orders') {
        console.log('🟡 [AppNavigator] Setting initial activeTab to: orders');
        return 'orders';
      }
      if (screenFromUrl.screen === 'contacts') {
        console.log('🟡 [AppNavigator] Setting initial activeTab to: contacts');
        return 'contacts';
      }
      if (screenFromUrl.screen === 'home' || screenFromUrl.screen === 'social' || 
          screenFromUrl.screen === 'performance' || screenFromUrl.screen === 'departments' || 
          screenFromUrl.screen === 'products') {
        console.log('🟡 [AppNavigator] Setting initial activeTab to:', screenFromUrl.screen);
        return screenFromUrl.screen;
      }
      if (screenFromUrl.screen === 'notifications' || screenFromUrl.screen === 'user-setup' || 
          screenFromUrl.screen === 'subscription') {
        console.log('🟡 [AppNavigator] Setting initial activeTab to: more');
        return 'more';
      }
    }
    console.log('🟡 [AppNavigator] Setting initial activeTab to default: home');
    return 'home';
  });
  const [isNavigating, setIsNavigating] = useState(false); // Prevent multiple redirects
  const [currentConversationId, setCurrentConversationId] = useState<string>('');
  const [currentProductParam, setCurrentProductParam] = useState<string>(''); // For product screens (productId or catalogueId)
  const [routeParams, setRouteParams] = useState<Record<string, any>>({}); // Route parameters from URL
  // `?contact=<id>` query param — read once at boot (see the init effect
  // below) and prop-drilled into whichever of Home/Contacts/Chat is active,
  // to restore a deep-linked contact's profile+conversation on page
  // load/refresh. Not kept in sync afterward here — useContactConversationPane
  // owns writing it back to the URL as the user opens/closes contacts.
  const [deepLinkContactId, setDeepLinkContactId] = useState<string | null>(null);
  // Opened once, by the screen it was meant for: kept set, every later visit to Home/Contacts/Inbox
  // reopened that contact (and the assistant saw a contact view instead of the dashboard).
  const clearDeepLinkContact = useCallback(() => setDeepLinkContactId(null), []);

  // Get auth state from centralized store
  const { 
    isAuthenticated, 
    tokens, 
    user, 
    isLoading,
    setUser, 
    setTokens, 
    setLoading, 
    logout: storeLogout,
    pendingEmail,
    setPendingEmail,
    isNewUser,
    setIsNewUser,
    initializeTokenManager,
    hasBusiness,
    currentBusiness,
    checkUserBusinesses,
    isBusinessLoading,
    setCurrentBusiness,
    setAuthState,
    bumpContactsRefreshToken
  } = useAppStore();

  // Get chat state for global conversation loading
  const { 
    conversations, 
    setConversations, 
    setLoading: setChatLoading,
    incrementUnreadCount,
    updateConversationLastMessage,
    bumpConversationsRefreshToken
  } = useChatStore();

  // Automatically sync API service with current tokens
  useEffect(() => {
    syncApiServiceWithStore(tokens);
  }, [tokens]);

  // Initialize TokenManager for centralized token refresh
  useEffect(() => {
    initializeTokenManager();
  }, [initializeTokenManager]);

  // Periodic token refresh check (every 5 minutes)
  useEffect(() => {
    if (!tokens?.token) return;

    const checkAndRefreshToken = async () => {
      try {
        const tokenPayload = JSON.parse(decodeBase64Url(tokens.token.split('.')[1]));
        const expirationTime = tokenPayload.exp * 1000;
        const currentTime = Date.now();
        const timeUntilExpiration = expirationTime - currentTime;
        const fiveMinutes = 5 * 60 * 1000;

        // If token will expire in less than 5 minutes, refresh it
        if (timeUntilExpiration > 0 && timeUntilExpiration < fiveMinutes) {
          console.log('🔄 [AppNavigator] Proactive token refresh: Token expiring soon');
          const { tokenManager } = await import('../services/token-manager');
          await tokenManager.refreshTokens();
        }
      } catch (error) {
        console.error('❌ [AppNavigator] Error in proactive token refresh:', error);
      }
    };

    // Check immediately
    checkAndRefreshToken();

    // Then check every 5 minutes
    const interval = setInterval(checkAndRefreshToken, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [tokens]);

  // Set up global authentication error handler
  useEffect(() => {
    console.log('🔐 [AppNavigator] Setting up global auth error handler');
    
    const handleAuthError = async () => {
      console.log('🔄 [AppNavigator] Auth error triggered - logging out and redirecting to login');
      
      // Check if user had remember-me enabled before clearing state
      const { loadCredentials } = await import('../utils/credentialManager');
      const hadRememberedCredentials = await loadCredentials();
      console.log('🔐 [AppNavigator] User had remembered credentials:', !!hadRememberedCredentials);
      
      // Clear all auth state
      storeLogout();
      apiService.setAuthToken(null);
      apiService.setRefreshToken(null);
      
      // Disconnect socket
      socketService.stopKeepAlive();
      socketService.disconnect();
      
      // Show notification
      setNotification({
        visible: true,
        type: 'error',
        title: 'Session Expired',
        message: hadRememberedCredentials 
          ? 'Your session has expired. Your credentials are saved for quick login.'
          : 'Your session has expired. Please login again.',
      });
      
      // Redirect to login
      // Note: Remember-me credentials are preserved in SecureStore/AsyncStorage
      // and will auto-fill on the login screen
      setCurrentScreen('unified-login');
      
      // Update URL for web
      if (Platform.OS === 'web') {
        window.history.pushState({}, '', '/unified-login');
      }
    };
    
    // Register the callback with API service
    apiService.setOnAuthError(handleAuthError);
    
    // Cleanup on unmount
    return () => {
      apiService.setOnAuthError(null);
    };
  }, [storeLogout, setCurrentScreen, setNotification]);

  // CRITICAL: Auto-login on app startup if user has remember-me credentials
  // This ensures users don't have to re-enter credentials after token expiration
  useEffect(() => {
    const attemptSilentLoginOnStartup = async () => {
      try {
        // Only attempt if not already authenticated and not currently loading
        if (isAuthenticated || isLoading || !tokens) {
          return;
        }

        const { loadCredentials } = await import('../utils/credentialManager');
        const savedCredentials = await loadCredentials();

        if (!savedCredentials?.email || !savedCredentials?.password) {
          console.log('ℹ️ [AppNavigator] No saved credentials for auto-login');
          return;
        }

        console.log('🔄 [AppNavigator] Attempting auto-login with saved credentials...');

        // Attempt silent login
        const response = await apiService.login({
          email: savedCredentials.email,
          password: savedCredentials.password,
        });

        if (response.statusCode === 1000 && response.data?.token && response.user) {
          console.log('✅ [AppNavigator] Auto-login succeeded! User restored from remember-me');
          const { token, refreshToken } = response.data;
          const userData = response.user;

          // Sync API service
          syncApiServiceWithStore({ token, refreshToken });

          // Set auth state atomically
          await setAuthState({
            tokens: { token, refreshToken },
            user: {
              id: userData.id || userData._id,
              email: userData.email,
              firstName: userData.firstName || '',
              lastName: userData.lastName || '',
              username: userData.email ? userData.email.split('@')[0] : '',
              isEmailVerified: userData.emailVerified || false,
              isActive: true,
              mobile: userData.mobile || userData.phone,
              phone: userData.phone || userData.mobile,
              timezone: userData.timezone,
              timezoneOffset: userData.timezoneOffset,
              country: userData.country,
              city: userData.city,
              avatar: userData.avatar || userData.profilePicture,
              profilePicture: userData.profilePicture || userData.avatar,
              preferences: userData.preferences,
              createdAt: userData.createdAt || new Date().toISOString(),
              updatedAt: userData.updatedAt || new Date().toISOString(),
            },
            source: 'token-refresh',
          });
        } else {
          console.warn('⚠️ [AppNavigator] Auto-login failed:', response.statusCode);
        }
      } catch (error) {
        console.error('❌ [AppNavigator] Auto-login error:', error);
      }
    };

    attemptSilentLoginOnStartup();
  }, []); // Run only once on mount

  // Global conversation loading function
  const loadGlobalConversations = useCallback(async () => {
    try {
      if (!isAuthenticated || !tokens?.token) {
        return;
      }

      setChatLoading(true);

      const result = await apiService.getUnifiedConversations();

      if (result.statusCode === 1000 && result.data) {
        // The API returns conversations nested under a 'conversations' property
        const conversationsData = result.data.conversations || result.data;
        
        if (Array.isArray(conversationsData)) {
          // Ensure all conversations have unreadCount field
          const conversationsWithUnreadCount = conversationsData.map((conv: any) => ({
            ...conv,
            unreadCount: conv.unreadCount || conv.messageCount || 0
          }));
          
          setConversations(conversationsWithUnreadCount);
        } else {
        }
      } else {
      }
    } catch (error) {
    } finally {
      setChatLoading(false);
    }
  }, [isAuthenticated, tokens, setConversations, setChatLoading]);

  // Load conversations when user is authenticated
  useEffect(() => {
    if (isAuthenticated && tokens?.token && hasBusiness) {
      loadGlobalConversations();
      
      // Join business room for business-wide updates
      const businessId = tokens?.token ? JSON.parse(decodeBase64Url(tokens.token.split('.')[1])).defaultBusinessId : null;
      if (businessId) {
        socketService.joinBusiness(businessId);
      }
    }
  }, [isAuthenticated, tokens, hasBusiness]); // Removed loadGlobalConversations from dependencies

  // Function to join business room for global notifications
  const joinBusinessRoom = async () => {
    try {
      if (currentBusiness?._id) {
        const businessId = currentBusiness._id;
        console.log('🔍 [AppNavigator] Joining business room:', businessId);
        await socketService.joinBusinessWithConfirmation(businessId);
      }
    } catch (error: any) {
      console.error('❌ [AppNavigator] Failed to join business room:', error);
    }
  };

  // Function to join conversation rooms (called from inbox or when conversations change)
  const joinConversationRooms = useCallback(
    async (conversationList?: Array<{ id?: string; conversationId?: string }>) => {
    try {
        const targetConversations = conversationList ?? conversations;
      
        if (!targetConversations || targetConversations.length === 0) {
          return;
        }
        
        targetConversations.forEach((conversation) => {
          const conversationId = conversation.conversationId || conversation.id;
          if (conversationId) {
            socketService.joinConversation(conversationId);
          }
        });
    } catch (error: any) {
      if (error.message?.includes('jwt expired') || error.message?.includes('jwt')) {
        try {
          const refreshSuccess = await socketService.handleTokenExpiration();
          if (refreshSuccess) {
            setTimeout(() => {
                joinConversationRooms(conversationList);
            }, 1000);
          }
        } catch (refreshError) {
        }
      }
    }
    },
    [conversations]
  );

  // Join business room when user is authenticated
  useEffect(() => {
    if (isAuthenticated && currentBusiness?._id && socketService.isConnected()) {
      joinBusinessRoom();
    }
  }, [isAuthenticated, currentBusiness?._id, socketService.isConnected()]);

  // Notifications are written on the server in the user's language — tell
  // it the app language after sign-in and whenever it changes.
  const appLanguage = useAppStore((st) => st.uiLocale);
  useEffect(() => {
    if (!isAuthenticated || !tokens?.token) return;
    const locale = String(appLanguage || '').startsWith('ar') ? 'ar' : 'en';
    apiService.authenticatedRequest('/api/notifications/locale', { method: 'PUT', body: JSON.stringify({ locale }) }).catch(() => {});
  }, [isAuthenticated, tokens?.token, appLanguage]);

  // Join conversation rooms when conversations are loaded
  useEffect(() => {
    if (conversations.length > 0) {
      joinConversationRooms(conversations);
    }
  }, [conversations, joinConversationRooms]);

  // Global socket listener for new messages
  useEffect(() => {
    if (isAuthenticated && tokens?.token) {
      
      socketService.onNewMessage((data) => {
         
        if (data.conversationId) {
          
          // Update conversation last message
          updateConversationLastMessage(
            data.conversationId,
            data.message?.content || 'New message',
            data.message?.timestamp || new Date().toISOString()
          );
          
          // Increment unread count
          incrementUnreadCount(data.conversationId);
          
        } else {
        }
      });
    }
  }, [isAuthenticated, tokens, updateConversationLastMessage, incrementUnreadCount]);


  // Initialize app with proper route and active tab
  useEffect(() => {
    if (Platform.OS === 'web') {
      // Get initial screen from URL on first load
      const hash = window.location.hash;
      const path = hash ? hash.substring(1) : window.location.pathname;
      const screenFromUrl = getScreenFromPath(path);
      
      // Set routeParams from URL on initial load
      if (screenFromUrl.params && Object.keys(screenFromUrl.params).length > 0) {
        setRouteParams(screenFromUrl.params);
      }

      // Restore a deep-linked contact (Home/Contacts/Chat's persistent pane)
      // from the URL's query string — getScreenFromPath only looks at the
      // path, never the query string, so this is read separately here.
      const contactFromUrl = new URLSearchParams(window.location.search).get('contact');
      if (contactFromUrl) {
        setDeepLinkContactId(contactFromUrl);
      }

      console.log('🌐 [AppNavigator] Web route check (ALWAYS RUNS):', {
        path,
        screenFromUrl,
        currentScreen,
        isAuthenticated,
        hasToken: !!tokens?.token,
        hasUser: !!user,
        isLoading,
        shouldRun: !isLoading
      });
      
      // Only proceed if not loading
      if (!isLoading) {
        console.log('🌐 [AppNavigator] Running route check logic...');
        
        // Debug: Test getScreenFromPath with /chat
        if (path === '/chat') {
          const testResult = getScreenFromPath('/chat');
          console.log('🔍 [AppNavigator] Testing /chat route:', testResult);
        }
        
        // Debug: Log all available routes
        console.log('🔍 [AppNavigator] Available routes:', {
          allRoutes: require('./web-routes').getAllRoutes(),
          isValidPath: require('./web-routes').isValidPath(path)
        });
        
        if (screenFromUrl.screen && screenFromUrl.screen !== currentScreen) {
          // If user is authenticated and trying to access a deep link, respect it
          if (isAuthenticated && tokens?.token && user) {
            console.log('✅ [AppNavigator] User authenticated, checking if screen is allowed:', screenFromUrl.screen);
            
            // An authenticated user may deep-link/refresh into any screen
            // EXCEPT the short pre-auth-only denylist (welcome/login/etc,
            // see navigation-guards.ts) — replaces the old allowlist, which
            // only covered a hand-maintained subset of the Screen union and
            // silently fell through to 'welcome' for anything missing from
            // it (e.g. refreshing on 'coupons' or 'data-lists').
            if (!isPreAuthOnlyScreen(screenFromUrl.screen)) {
              console.log('🎯 [AppNavigator] Setting authenticated screen:', screenFromUrl.screen);
              setCurrentScreen(screenFromUrl.screen as Screen);
              
              // Handle conversation parameters
              if (screenFromUrl.screen === 'conversation' && screenFromUrl.params?.id) {
                setCurrentConversationId(screenFromUrl.params.id);
              }
              
              // Handle task history parameters (store taskId for TaskHistoryScreen)
              if (screenFromUrl.screen === 'task-history' && screenFromUrl.params?.taskId) {
                // Store taskId for TaskHistoryScreen to access (cross-platform)
                import('../utils/tempStorage').then(({ setPendingTaskId }) => {
                  setPendingTaskId(screenFromUrl.params.taskId);
                });
              }
              
              // Handle product screen parameters
              if ((screenFromUrl.screen === 'products' || screenFromUrl.screen === 'products-list' || 
                   screenFromUrl.screen === 'product-create' || 
                   screenFromUrl.screen === 'product-bulk-import')) {
                const catalogueId = screenFromUrl.params?.catalogueId || 'default';
                setCurrentProductParam(catalogueId);
                setRouteParams(screenFromUrl.params || {});
              } else if ((screenFromUrl.screen === 'product-detail' || screenFromUrl.screen === 'product-edit') && 
                         screenFromUrl.params?.productId) {
                setCurrentProductParam(screenFromUrl.params.productId);
                setRouteParams(screenFromUrl.params);
              } else if (screenFromUrl.screen === 'order-edit' && 
                         screenFromUrl.params?.orderId) {
                setCurrentProductParam(screenFromUrl.params.orderId);
                setRouteParams(screenFromUrl.params);
              } else if (screenFromUrl.screen === 'department-edit' && 
                         screenFromUrl.params?.departmentId) {
                setCurrentProductParam(screenFromUrl.params.departmentId);
                setRouteParams(screenFromUrl.params);
              } else if ((screenFromUrl.screen === 'catalogue-detail' || screenFromUrl.screen === 'catalogue-edit' || screenFromUrl.screen === 'add-products-to-catalogue' || screenFromUrl.screen === 'manage-catalogue-channels') && 
                         screenFromUrl.params?.catalogueId) {
                setCurrentProductParam(screenFromUrl.params.catalogueId);
                setRouteParams(screenFromUrl.params);
              } else if (screenFromUrl.screen === 'event-create') {
                // Handle event-create with or without calendarId
                if (screenFromUrl.params?.calendarId) {
                  setCurrentProductParam(screenFromUrl.params.calendarId);
                }
                setRouteParams(screenFromUrl.params || {});
              } else if (screenFromUrl.screen === 'event-edit') {
                // Handle event-edit with or without eventId
                if (screenFromUrl.params?.eventId) {
                  setCurrentProductParam(screenFromUrl.params.eventId);
                }
                setRouteParams(screenFromUrl.params || {});
              } else if (screenFromUrl.screen === 'business-calendar') {
                // Handle business-calendar with or without calendarId
                if (screenFromUrl.params?.calendarId) {
                  setCurrentProductParam(screenFromUrl.params.calendarId);
                }
                setRouteParams(screenFromUrl.params || {});
              } else if (screenFromUrl.screen === 'calendars') {
                setRouteParams(screenFromUrl.params || {});
              } else if (screenFromUrl.screen === 'shipping-method-edit' &&
                         screenFromUrl.params?.methodId) {
                setCurrentProductParam(screenFromUrl.params.methodId);
                setRouteParams(screenFromUrl.params);
              } else if (screenFromUrl.screen === 'order-add') {
                setRouteParams(screenFromUrl.params || {});
              } else if (screenFromUrl.screen === 'flow-edit') {
                // Handle flow-edit with or without flowId (create vs edit)
                if (screenFromUrl.params?.flowId) {
                  setCurrentProductParam(screenFromUrl.params.flowId);
                }
                setRouteParams(screenFromUrl.params || {});
              } else if ((screenFromUrl.screen === 'lead-run' || screenFromUrl.screen === 'assignment-rule-edit') && screenFromUrl.params?.id) {
                setCurrentProductParam(screenFromUrl.params.id);
                setRouteParams(screenFromUrl.params);
              } else if ((screenFromUrl.screen === 'data-list-schema-edit' || screenFromUrl.screen === 'data-list-records') &&
                         screenFromUrl.params?.id) {
                setCurrentProductParam(screenFromUrl.params.id);
                setRouteParams(screenFromUrl.params);
              } else if (screenFromUrl.screen === 'data-list-record-create' && screenFromUrl.params?.listId) {
                setRouteParams(screenFromUrl.params);
              } else if (screenFromUrl.screen === 'data-list-record-edit' &&
                         screenFromUrl.params?.listId && screenFromUrl.params?.recordId) {
                setCurrentProductParam(screenFromUrl.params.recordId);
                setRouteParams(screenFromUrl.params);
              } else if ((screenFromUrl.screen === 'visit-detail' || screenFromUrl.screen === 'visit-execute') &&
                         screenFromUrl.params?.visitId) {
                // Was entirely unhandled — a reload on visit-execute (or
                // visit-detail) had no URL param to restore visitId from,
                // so routeParams stayed empty and the screen crashed on an
                // undefined visit id. VisitExecuteScreen/VisitDetailScreen
                // read routeParams?.visitId directly (no separate "current
                // product param" style variable), so this only needs
                // setRouteParams.
                setRouteParams(screenFromUrl.params);
              } else if (screenFromUrl.screen === 'visit-campaign-detail' && screenFromUrl.params?.campaignId) {
                setRouteParams(screenFromUrl.params);
              }

              // Set active tab for tab screens
              if (screenFromUrl.screen === 'home' || screenFromUrl.screen === 'social' || screenFromUrl.screen === 'performance' || screenFromUrl.screen === 'departments' || screenFromUrl.screen === 'products') {
                setActiveTab(screenFromUrl.screen);
              } else if (screenFromUrl.screen === 'contacts') {
                setActiveTab('contacts');
              } else if (screenFromUrl.screen === 'business-calendar') {
                setActiveTab('calendar');
              } else if (screenFromUrl.screen === 'orders') {
                setActiveTab('orders');
              } else if (screenFromUrl.screen === 'notifications' || screenFromUrl.screen === 'user-setup' || screenFromUrl.screen === 'subscription') {
                setActiveTab('more');
              }
              return;
            }
          }
          // For unauthenticated users, redirect to welcome for protected routes
          if (isAuthRequiredScreen(screenFromUrl.screen)) {
            console.log('🔒 [AppNavigator] Protected route accessed without auth, redirecting to welcome');
            setCurrentScreen('welcome');
            if (typeof window !== 'undefined') {
              window.history.replaceState({ screen: 'welcome' }, '', '/');
            }
            return;
          }
          
          // For unauthenticated users accessing public routes, allow them
          console.log('🔓 [AppNavigator] Setting unauthenticated screen:', screenFromUrl.screen);
          setCurrentScreen(screenFromUrl.screen as Screen);
          // Also set the active tab if it's a tab screen
          if (screenFromUrl.screen === 'home' || screenFromUrl.screen === 'social' || screenFromUrl.screen === 'performance' || screenFromUrl.screen === 'departments' || screenFromUrl.screen === 'products') {
            setActiveTab(screenFromUrl.screen);
          } else if (screenFromUrl.screen === 'contacts') {
            setActiveTab('contacts');
          } else if (screenFromUrl.screen === 'business-calendar') {
            setActiveTab('calendar');
          } else if (screenFromUrl.screen === 'orders') {
            setActiveTab('orders');
          } else if (screenFromUrl.screen === 'notifications' || screenFromUrl.screen === 'user-setup' || screenFromUrl.screen === 'subscription') {
            setActiveTab('more');
          }
        } else if (!screenFromUrl.screen && path !== '/') {
          // Route not found, but not root - show 404 or redirect to welcome
          console.log('❌ [AppNavigator] Route not found:', path);
          setCurrentScreen('welcome');
          // Optionally redirect to welcome page
          if (typeof window !== 'undefined') {
            window.history.replaceState({ screen: 'welcome' }, '', '/');
          }
        } else if (!currentScreen) {
          // If no URL and no current screen, default to welcome
          console.log('🏠 [AppNavigator] No URL or current screen, defaulting to welcome');
          setCurrentScreen('welcome');
        }
      } else {
        console.log('⏸️ [AppNavigator] Skipping route check - still loading');
      }
    }
  }, [isLoading, isAuthenticated, tokens, user]); // Wait for loading to complete and auth state

  // Web-specific URL routing and sync
  useEffect(() => {
    if (Platform.OS === 'web') {
      // Listen for browser navigation (back/forward buttons)
      const handlePopState = (event: PopStateEvent) => {
        const hash = window.location.hash;
        const path = hash ? hash.substring(1) : window.location.pathname;
        const screenFromUrl = getScreenFromPath(path);
        // Prefer the id/params pushed into history.state by navigateTo (see the
        // pushState/replaceState calls below) — the URL path alone can't reconstruct params
        // for screens like flow-edit that have no dynamic :id route pattern registered in
        // web-routes.ts, so falling back to screenFromUrl.params-only would lose the id.
        const historyState = event.state as { screen?: string; conversationId?: string; additionalParams?: Record<string, any> } | null;

        // Read the LIVE current screen via ref, not the `currentScreen` closed over when this
        // listener was registered (this effect runs once, mount-only) — otherwise this compares
        // against a permanently stale value and can silently no-op (URL changes, screen doesn't).
        if (screenFromUrl.screen && screenFromUrl.screen !== currentScreenRef.current) {
          setCurrentScreen(screenFromUrl.screen as Screen);
          if (historyState?.conversationId) {
            setCurrentConversationId(historyState.conversationId);
            setCurrentProductParam(historyState.conversationId);
          }
          if (historyState?.additionalParams) {
            setRouteParams(historyState.additionalParams);
          } else if (screenFromUrl.params && Object.keys(screenFromUrl.params).length > 0) {
            setRouteParams(screenFromUrl.params);
          }
          // Update active tab for tab screens
          if (screenFromUrl.screen === 'home' || screenFromUrl.screen === 'social' || screenFromUrl.screen === 'performance' || screenFromUrl.screen === 'departments' || screenFromUrl.screen === 'products') {
            setActiveTab(screenFromUrl.screen);
          } else if (screenFromUrl.screen === 'contacts') {
            setActiveTab('contacts');
          } else if (screenFromUrl.screen === 'business-calendar') {
            setActiveTab('calendar');
          } else if (screenFromUrl.screen === 'orders') {
            setActiveTab('orders');
          } else if (screenFromUrl.screen === 'notifications' || screenFromUrl.screen === 'user-setup' || screenFromUrl.screen === 'subscription') {
            setActiveTab('more');
          }
        }
      };

      window.addEventListener('popstate', handlePopState);
      return () => window.removeEventListener('popstate', handlePopState);
    }
  }, []); // Only run once to set up event listener

  // Navigation function that updates URL for web
  const navigateTo = useCallback((screen: Screen, conversationId?: string, additionalParams?: Record<string, any>) => {
    // On iOS the legacy Paymob payment screen stays off unless billing is
    // enabled. Billing ('subscription') is always reachable: it shows plan
    // status and trials, and hides paying itself when the flag is off.
    if (Platform.OS === 'ios' && !FEATURE_FLAGS.IOS_BILLING_ENABLED && screen === 'payment') {
      return;
    }
    
    // Don't navigate if we're already on the same screen (with the same id param AND the same
    // additionalParams) or if we're in the middle of navigation. Re-navigating to the SAME
    // screen with a DIFFERENT id must NOT be swallowed here — e.g. creating a flow renders
    // FlowEditScreen with flowId=undefined on the 'flow-edit' screen, then saving calls
    // navigateTo('flow-edit', newFlowId) to drop into edit mode for the flow just created;
    // without this check that call was a same-screen no-op (currentProductParam never
    // updated), leaving edit-mode actions (Publish, Versions) missing until a hard reload
    // re-derived everything from the URL fresh. The same applies to a screen re-navigating to
    // ITSELF with different additionalParams (e.g. ChannelOnboardingStepper advancing its own
    // stepIndex via routeParams) — comparing only conversationId/currentProductParam treated
    // that as a no-op too, silently swallowing Skip/Continue.
    const additionalParamsChanged = additionalParams !== undefined &&
      JSON.stringify(additionalParams) !== JSON.stringify(routeParams);
    const isSameScreenSameParam = screen === currentScreen
      && (conversationId || '') === (currentProductParam || '')
      && !additionalParamsChanged;
    if (isSameScreenSameParam || isNavigating) {
      // Still refresh conversations if re-navigating to chat
      if (screen === 'chat') {
        bumpConversationsRefreshToken();
      }
      return;
    }
    
    setIsNavigating(true);
    setCurrentScreen(screen);

    if (screen === 'chat') {
      bumpConversationsRefreshToken();
    }
    
    // Set route parameters from additionalParams or extract from URL
    if (additionalParams) {
      setRouteParams(additionalParams);
    } else if (Platform.OS === 'web') {
      // Extract params from current URL
      const path = window.location.pathname;
      const routeResult = getScreenFromPath(path);
      if (routeResult.params && Object.keys(routeResult.params).length > 0) {
        setRouteParams(routeResult.params);
      } else {
        setRouteParams({});
      }
    } else {
      setRouteParams({});
    }
    
    // Set conversation ID if provided
    if (screen === 'conversation' && conversationId) {
      console.log('🔍 [AppNavigator] Setting conversation ID:', conversationId);
      setCurrentConversationId(conversationId);
    }
    
    // Set product parameter if provided (for product screens)
    if ((screen === 'products' || screen === 'products-list' || screen === 'product-detail' || 
         screen === 'product-create' || screen === 'product-edit' || screen === 'product-bulk-import')) {
      const paramValue = conversationId || 'default';
      console.log('🔍 [AppNavigator] Setting product parameter:', paramValue);
      setCurrentProductParam(paramValue);
    }
    
    // Set catalogue parameter if provided (for catalogue screens)
    if ((screen === 'catalogue-detail' || screen === 'catalogue-edit' || screen === 'add-products-to-catalogue')) {
      const paramValue = conversationId || '';
      console.log('🔍 [AppNavigator] Setting catalogue parameter:', paramValue);
      setCurrentProductParam(paramValue);
    }
    
    // Set quick reply set/item parameter if provided (for quick reply set/item screens)
    if ((screen === 'quick-reply-set-detail' || screen === 'quick-reply-set-edit' || screen === 'quick-reply-set-items' || screen === 'quick-reply-item-create' || screen === 'quick-reply-item-edit')) {
      const paramValue = conversationId || '';
      console.log('🔍 [AppNavigator] Setting quick reply set/item parameter:', paramValue);
      setCurrentProductParam(paramValue);
    }

    // Set dispatch rule parameter if provided (ruleId for dispatch-rule-edit; scope/attachedTo
    // come from additionalParams via routeParams, set above)
    if (screen === 'dispatch-rule-edit') {
      const paramValue = conversationId || '';
      console.log('🔍 [AppNavigator] Setting dispatch rule parameter:', paramValue);
      setCurrentProductParam(paramValue);
    }

    // Set flow parameter if provided (flowId for flow-edit)
    if (screen === 'flow-edit') {
      const paramValue = conversationId || '';
      console.log('🔍 [AppNavigator] Setting flow parameter:', paramValue);
      setCurrentProductParam(paramValue);
    }

    // Set data-list parameter — the primary id is the listId (for schema-edit/records) or the
    // recordId (for record-edit); the secondary listId for record screens rides in routeParams.
    if (
      screen === 'data-list-schema-edit' ||
      screen === 'data-list-records' ||
      screen === 'data-list-record-create' ||
      screen === 'data-list-record-edit' ||
      screen === 'lead-run' ||
      screen === 'assignment-rule-edit'
    ) {
      const paramValue = conversationId || '';
      console.log('🔍 [AppNavigator] Setting data list parameter:', paramValue);
      setCurrentProductParam(paramValue);
    }
    
    // Set calendar parameter if provided (for calendar screens)
    if ((screen === 'calendar-edit' || screen === 'calendar-events')) {
      const paramValue = conversationId || '';
      console.log('🔍 [AppNavigator] Setting calendar parameter:', paramValue);
      setCurrentProductParam(paramValue);
    }
    
    // Set event parameter if provided (for event screens)
    if ((screen === 'event-edit' || screen === 'event-detail')) {
      const paramValue = conversationId || '';
      console.log('🔍 [AppNavigator] Setting event parameter:', paramValue);
      setCurrentProductParam(paramValue);
    }
    
    // Set calendar parameter for event-create screen
    if (screen === 'event-create' && conversationId) {
      const paramValue = conversationId;
      console.log('🔍 [AppNavigator] Setting calendar parameter for event-create:', paramValue);
      setCurrentProductParam(paramValue);
    }
    
    // Set shipping method parameter for shipping-method-edit screen
    if (screen === 'shipping-method-edit' && conversationId) {
      const paramValue = conversationId;
      console.log('🔍 [AppNavigator] Setting shipping method parameter:', paramValue);
      setCurrentProductParam(paramValue);
    }

    // Set order parameter for order-edit screen
    if (screen === 'order-edit' && conversationId) {
      const paramValue = conversationId;
      console.log('🔍 [AppNavigator] Setting order parameter for order-edit:', paramValue);
      setCurrentProductParam(paramValue);
    }
    
    // Set department parameter for department-edit screen
    if (screen === 'department-edit' && conversationId) {
      const paramValue = conversationId;
      console.log('🔍 [AppNavigator] Setting department parameter for department-edit:', paramValue);
      setCurrentProductParam(paramValue);
      if (Platform.OS === 'web' && additionalParams) {
        setRouteParams({ ...additionalParams, departmentId: paramValue });
      } else if (Platform.OS === 'web') {
        setRouteParams({ departmentId: paramValue });
      }
    }

    // Set vendor parameter for vendor-edit/vendor-detail/vendor-add-products screens
    if ((screen === 'vendor-edit' || screen === 'vendor-detail' || screen === 'vendor-add-products') && conversationId) {
      const paramValue = conversationId;
      console.log('🔍 [AppNavigator] Setting vendor parameter:', paramValue);
      setCurrentProductParam(paramValue);
    }

    // Set quotation parameter for quotation-edit/quotation-detail/quotation-template-edit screens
    if ((screen === 'quotation-edit' || screen === 'quotation-detail' || screen === 'quotation-template-edit') && conversationId) {
      const paramValue = conversationId;
      console.log('🔍 [AppNavigator] Setting quotation parameter:', paramValue);
      setCurrentProductParam(paramValue);
    }

    // Update active tab when navigating to tab screens
    if (screen === 'home' || screen === 'social' || screen === 'performance' || screen === 'departments' || screen === 'products') {
      setActiveTab(screen);
    } else if (screen === 'contacts') {
      setActiveTab('contacts');
    } else if (screen === 'business-calendar') {
      setActiveTab('calendar'); // Map business-calendar to calendar tab
    } else if (screen === 'orders') {
      setActiveTab('orders');
    } else if (screen === 'notifications' || screen === 'user-setup' || screen === 'subscription') {
      setActiveTab('more'); // These screens are part of the More menu
    }
    
    // Update URL for web - but be careful not to override deep links
    if (Platform.OS === 'web') {
      let path: string;
      
      // If navigating to conversation and we have a conversation ID, use the parameterized route
      if (screen === 'conversation' && (conversationId || currentConversationId)) {
        const idToUse = conversationId || currentConversationId;
        console.log('🔍 [AppNavigator] Navigating to conversation with ID:', idToUse);
        
        // Use the function call to get the path
        path = getPathFromScreen(screen, { id: idToUse });
        console.log('🔍 [AppNavigator] Function path result:', path);
      } else if ((screen === 'products' || screen === 'products-list' || screen === 'product-create' || 
                  screen === 'product-bulk-import')) {
        const idToUse = conversationId || currentProductParam || 'default';
        console.log('🔍 [AppNavigator] Navigating to product screen with catalogue ID:', idToUse);
        const targetScreen = screen === 'products' ? 'products-list' : screen;
        const paramKey = 'catalogueId';
        path = getPathFromScreen(targetScreen, { [paramKey]: idToUse });
        console.log('🔍 [AppNavigator] Function path result:', path);
      } else if ((screen === 'catalogue-detail' || screen === 'catalogue-edit' || screen === 'add-products-to-catalogue') && 
                 (conversationId || currentProductParam)) {
        const idToUse = conversationId || currentProductParam;
        console.log('🔍 [AppNavigator] Navigating to catalogue screen with catalogue ID:', idToUse);
        const paramKey = 'catalogueId';
        path = getPathFromScreen(screen, { [paramKey]: idToUse });
        console.log('🔍 [AppNavigator] Catalogue path result:', path);
      } else if ((screen === 'product-detail' || screen === 'product-edit') && 
                 (conversationId || currentProductParam)) {
        const idToUse = conversationId || currentProductParam;
        console.log('🔍 [AppNavigator] Navigating to product screen with product ID:', idToUse);
        path = getPathFromScreen(screen, { productId: idToUse });
        console.log('🔍 [AppNavigator] Function path result:', path);
      } else if (screen === 'department-edit' && (conversationId || currentProductParam)) {
        const idToUse = conversationId || currentProductParam;
        console.log('🔍 [AppNavigator] Navigating to department edit with department ID:', idToUse);
        path = getPathFromScreen(screen, { departmentId: idToUse });
        console.log('🔍 [AppNavigator] Department edit path result:', path);
      } else if ((screen === 'quick-reply-set-detail' || screen === 'quick-reply-set-edit' || screen === 'quick-reply-set-items' || screen === 'quick-reply-item-create') && 
                 (conversationId || currentProductParam)) {
        const idToUse = conversationId || currentProductParam;
        console.log('🔍 [AppNavigator] Navigating to quick reply set/item screen with setId:', idToUse);
        const paramKey = 'setId';
        path = getPathFromScreen(screen, { setId: idToUse });
        console.log('🔍 [AppNavigator] Quick reply set/item path result:', path);
      } else if (screen === 'quick-reply-item-edit' && (conversationId || currentProductParam)) {
        const idToUse = conversationId || currentProductParam;
        console.log('🔍 [AppNavigator] Navigating to quick reply item edit screen with itemId:', idToUse);
        path = getPathFromScreen(screen, { itemId: idToUse });
        console.log('🔍 [AppNavigator] Quick reply item edit path result:', path);
      } else if ((screen === 'calendar-edit' || screen === 'calendar-events') && (conversationId || currentProductParam)) {
        const idToUse = conversationId || currentProductParam;
        console.log('🔍 [AppNavigator] Navigating to calendar screen with calendarId:', idToUse);
        path = getPathFromScreen(screen, { calendarId: idToUse });
        console.log('🔍 [AppNavigator] Calendar screen path result:', path);
      } else if (screen === 'shipping-method-edit' && (conversationId || currentProductParam)) {
        const idToUse = conversationId || currentProductParam;
        console.log('🔍 [AppNavigator] Navigating to shipping-method-edit screen with methodId:', idToUse);
        path = getPathFromScreen(screen, { methodId: idToUse });
        console.log('🔍 [AppNavigator] Shipping method edit path result:', path);
      } else if (screen === 'order-edit' && (conversationId || currentProductParam)) {
        const idToUse = conversationId || currentProductParam;
        console.log('🔍 [AppNavigator] Navigating to order-edit screen with orderId:', idToUse);
        path = getPathFromScreen(screen, { orderId: idToUse });
        console.log('🔍 [AppNavigator] Order edit path result:', path);
      } else if (screen === 'event-create' && (conversationId || currentProductParam)) {
        const idToUse = conversationId || currentProductParam;
        console.log('🔍 [AppNavigator] Navigating to event-create screen with calendarId:', idToUse);
        path = getPathFromScreen(screen, { calendarId: idToUse });
        console.log('🔍 [AppNavigator] Event-create screen path result:', path);
      } else if ((screen === 'event-edit' || screen === 'event-detail') && (conversationId || currentProductParam)) {
        const idToUse = conversationId || currentProductParam;
        console.log('🔍 [AppNavigator] Navigating to event screen with eventId:', idToUse);
        path = getPathFromScreen(screen, { eventId: idToUse });
        console.log('🔍 [AppNavigator] Event screen path result:', path);
      } else if (screen === 'task-history') {
        // For task-history, check if there's a pending task ID. The
        // pendingTaskId lookup is async, so the shared pushState/
        // replaceState block below (which runs synchronously against
        // `path`) is skipped for this screen entirely (see the `screen !==
        // 'task-history'` guard) — pushing the default '/task-history' path
        // immediately and then a SECOND, independent history entry once the
        // taskId resolves corrupted Back (two entries for one navigation).
        // This branch owns its own single pushState instead.
        path = getPathFromScreen(screen);
        import('../utils/tempStorage').then(({ getPendingTaskId }) => {
          getPendingTaskId().then(taskId => {
            const taskPath = taskId ? `/task-history/${taskId}` : getPathFromScreen(screen);
            console.log('🔍 [AppNavigator] Navigating to task-history, resolved path:', taskPath);
            window.history.pushState({ screen, conversationId, additionalParams }, '', taskPath);
          }).catch(() => {
            window.history.pushState({ screen, conversationId, additionalParams }, '', getPathFromScreen(screen));
          });
        });
      } else if (screen === 'flow-edit' && (conversationId || currentProductParam)) {
        const idToUse = conversationId || currentProductParam;
        console.log('🔍 [AppNavigator] Navigating to flow-edit screen with flowId:', idToUse);
        path = getPathFromScreen(screen, { flowId: idToUse });
        console.log('🔍 [AppNavigator] Flow edit path result:', path);
      } else if (screen === 'business-calendar' && (conversationId || currentProductParam)) {
        const idToUse = conversationId || currentProductParam;
        console.log('🔍 [AppNavigator] Navigating to calendar screen with calendarId:', idToUse);
        // Use /calendar path instead of /business-calendar
        path = `/calendar/${idToUse}`;
        console.log('🔍 [AppNavigator] Calendar screen path result:', path);
      } else if (screen === 'data-list-schema-edit' && (conversationId || currentProductParam)) {
        const idToUse = conversationId || currentProductParam;
        path = getPathFromScreen(screen, { id: idToUse });
      } else if ((screen === 'lead-run' || screen === 'assignment-rule-edit') && (conversationId || currentProductParam)) {
        path = getPathFromScreen(screen, { id: conversationId || currentProductParam });
      } else if (screen === 'data-list-records' && (conversationId || currentProductParam)) {
        const idToUse = conversationId || currentProductParam;
        path = getPathFromScreen(screen, { id: idToUse });
      } else if (screen === 'data-list-record-create' && additionalParams?.listId) {
        path = getPathFromScreen(screen, { listId: additionalParams.listId });
      } else if (screen === 'data-list-record-edit' && (conversationId || currentProductParam) && additionalParams?.listId) {
        const idToUse = conversationId || currentProductParam;
        path = getPathFromScreen(screen, { listId: additionalParams.listId, recordId: idToUse });
      } else if ((screen === 'visit-detail' || screen === 'visit-execute') && additionalParams?.visitId) {
        // Was entirely unhandled — visitId only ever lived in in-memory
        // routeParams (via additionalParams here), never reflected into the
        // URL, so a browser reload on either screen had nothing to restore
        // from and crashed on an undefined visitId. Mirrors the
        // data-list-record-edit pattern just above.
        path = getPathFromScreen(screen, { visitId: additionalParams.visitId });
      } else if (screen === 'visit-campaign-detail' && additionalParams?.campaignId) {
        path = getPathFromScreen(screen, { campaignId: additionalParams.campaignId });
      } else if (['cart', 'checkout', 'catalog-view', 'product-view', 'order-success', 'track-order'].includes(screen)) {
        // These storefront screens carry their context (catalogId/productId/
        // businessId/phoneNumber/...) as URL query params rather than a
        // :id path segment — getPathFromScreen has no query-string support,
        // so without this these screens' own navigateTo calls would drop
        // that context from the URL entirely. This used to be exactly why
        // those screens called window.location.href directly instead of
        // navigateTo: a hard reload was the only way they had to keep the
        // query string. Building it from additionalParams when given (falls
        // back to the current URL's own query string otherwise, e.g. a
        // same-screen refresh with no new params to set) removes that need.
        const sourceParams: Record<string, any> = additionalParams || (() => {
          const fromUrl: Record<string, string> = {};
          new URLSearchParams(window.location.search).forEach((v, k) => { fromUrl[k] = v; });
          return fromUrl;
        })();
        const qs = new URLSearchParams();
        Object.keys(sourceParams).forEach((k) => {
          const v = sourceParams[k];
          if (v !== undefined && v !== null && v !== '') qs.append(k, String(v));
        });
        const qsStr = qs.toString();
        path = `/${screen}${qsStr ? '?' + qsStr : ''}`;
      } else {
        path = getPathFromScreen(screen);
        console.log('🔍 [AppNavigator] getPathFromScreen result for', screen, ':', path);
      }
      
      // Special case: if screen is business-calendar without ID, use /calendar
      if (screen === 'business-calendar' && !conversationId && !currentProductParam) {
        path = '/calendar';
      }
      
      console.log('🔍 [AppNavigator] Final path for navigation:', path, 'type:', typeof path);
      
      // Ensure path is a string
      if (typeof path !== 'string') {
        console.error('🔍 [AppNavigator] Path is not a string:', path);
        path = `/${screen}`;
      }
      
      const currentPath = window.location.pathname;

      // Only update URL if it's different and we're not overriding a deep link.
      // task-history pushes its own single history entry once its async
      // taskId lookup resolves (see above) — pushing here too would add a
      // second, premature entry for the same navigation.
      if (currentPath !== path && screen !== 'task-history') {
        console.log('🔍 [AppNavigator] Updating URL from', currentPath, 'to', path);
        // Carry conversationId/additionalParams in history state (not just the URL path) so
        // popstate (browser back/forward) can restore them even for screens like flow-edit
        // that have no dynamic :id route pattern registered in web-routes.ts — the URL alone
        // can't reconstruct which flow was being edited, but the history entry can.
        const historyState = { screen, conversationId, additionalParams };
        // pushState for every genuine navigation, including tab switches —
        // Back is expected to step through tab history too, not just skip
        // straight past it (the old replaceState special-case for
        // home/social/performance broke Back for tab navigation).
        window.history.pushState(historyState, '', path);
      }
    }
    
    // Reset navigation flag after a short delay
    setTimeout(() => {
      setIsNavigating(false);
    }, 100);
  }, [currentScreen, isNavigating, currentConversationId, setNotification, routeParams]);
  // Notification taps run from long-lived listeners: always the current navigateTo
  const navigateToRef = useRef(navigateTo);
  navigateToRef.current = navigateTo;

  // Any 423 (business locked, subscription ended) opens Billing, where the
  // owner can pay; once.
  useEffect(() => {
    setBusinessLockedHandler(() => {
      if (currentScreenRef.current !== 'subscription' && currentScreenRef.current !== 'plan-selection' && currentScreenRef.current !== 'billing-return') {
        navigateTo('subscription');
      }
    });
    return () => setBusinessLockedHandler(null);
  }, [navigateTo]);

  // Android hardware/gesture Back: run the visible header's own back action
  // (same as tapping its arrow); screens without one fall back to Home, and
  // Back on Home (or before sign-in) leaves the app as usual.
  useEffect(() => {
    if (Platform.OS !== 'android') return;
    const sub = BackHandler.addEventListener('hardwareBackPress', () => {
      // Checked first: Contacts/Inbox stay mounted (hidden) beside Home and
      // their headers' back actions would otherwise swallow the exit.
      if (currentScreen === 'home') return false;
      const headerBack = getRegisteredBackAction();
      if (headerBack) {
        headerBack();
        return true;
      }
      if (isAuthenticated && !isPreAuthOnlyScreen(currentScreen)) {
        setActiveTab('home');
        navigateTo('home');
        return true;
      }
      return false;
    });
    return () => sub.remove();
  }, [currentScreen, isAuthenticated, navigateTo]);

  // CalendarReminderAlertRoot is mounted at the App.tsx root (a sibling of
  // AppNavigator, for a true full-screen takeover regardless of
  // currentScreen) so it can't call this component's own navigateTo
  // directly — "View Event" instead writes a pendingNavigation request to
  // the shared store; this effect is the other half of that bridge.
  const pendingNavigation = useCalendarReminderStore((state) => state.pendingNavigation);
  const clearPendingNavigation = useCalendarReminderStore((state) => state.clearPendingNavigation);
  useEffect(() => {
    if (!pendingNavigation) return;
    navigateTo(pendingNavigation.screen as Screen, pendingNavigation.param);
    clearPendingNavigation();
  }, [pendingNavigation, navigateTo, clearPendingNavigation]);

  // Native: Universal Links / App Links (https://connect.dislix.com/...) and
  // the dislix:// scheme open the same screen the web app would for that
  // path. A link to a signed-in screen opened while signed out waits here
  // until login finishes, then opens.
  const [pendingAppLink, setPendingAppLink] = useState<string | null>(null);
  useEffect(() => {
    if (Platform.OS === 'web') return;
    Linking.getInitialURL()
      .then((url) => { if (url) setPendingAppLink(url); })
      .catch(() => {});
    const subscription = Linking.addEventListener('url', ({ url }) => setPendingAppLink(url));
    return () => subscription.remove();
  }, []);
  useEffect(() => {
    if (!pendingAppLink || isLoading) return;
    const link = parseAppLink(pendingAppLink);
    if (!link) {
      setPendingAppLink(null);
      return;
    }
    const signedIn = !!(isAuthenticated && tokens?.token && user);
    const route = link.path === '/' ? { screen: 'contacts', params: {} as Record<string, string> } : getScreenFromPath(link.path);
    if (!route.screen) {
      setPendingAppLink(null);
      return;
    }
    if (!signedIn && isAuthRequiredScreen(route.screen)) return;
    setPendingAppLink(null);
    if (signedIn && isPreAuthOnlyScreen(route.screen)) return;

    if (link.contactId) setDeepLinkContactId(link.contactId);
    const params = route.params || {};
    if (route.screen === 'task-history' && params.taskId) {
      import('../utils/tempStorage').then(({ setPendingTaskId }) => setPendingTaskId(params.taskId));
    }
    const idKey = APP_LINK_ID_KEYS.find((key) => params[key]);
    navigateTo(route.screen as Screen, idKey ? params[idKey] : undefined, params);
  }, [pendingAppLink, isLoading, isAuthenticated, tokens, user, navigateTo]);

  // Memoize the business check function to prevent infinite loops
  const checkBusinessStatus = useCallback(async () => {
    if (isNavigating || isBusinessLoading) {
      console.log('⏸️ [AppNavigator] Skipping business check - navigating or loading');
      return;
    }
    
    if (isAuthenticated && tokens?.token && user) {
      console.log('🔍 [AppNavigator] Checking business status for authenticated user');
      
      // Only redirect if user is on welcome screen (NOT login, register, etc.)
      // This prevents automatic redirect when user is explicitly on login screen
      const shouldCheckBusinessRedirect = currentScreen === 'welcome';
      
      console.log('🎯 [AppNavigator] Should check business redirect:', shouldCheckBusinessRedirect, 'Current screen:', currentScreen);
      
      if (!shouldCheckBusinessRedirect) {
        console.log('✅ [AppNavigator] Not on welcome screen, skipping business redirect check');
        return;
      }
      
      // 🔥 CRITICAL FIX: Check if business already exists in memory (from recent login)
      // This prevents race condition where checkBusinessStatus runs before navigateTo('home') completes
      if (currentBusiness && hasBusiness) {
        console.log('✅ [AppNavigator] Business already exists in memory:', currentBusiness._id, '- navigating to home');
        
        // Check for deep links before redirecting
        if (Platform.OS === 'web') {
          const path = window.location.pathname;
          const screenFromUrl = getScreenFromPath(path);
          
          if (screenFromUrl.screen && screenFromUrl.screen !== 'welcome' && screenFromUrl.screen !== 'login' && screenFromUrl.screen !== 'register' && screenFromUrl.screen !== 'otp-verification' && screenFromUrl.screen !== 'forgot-password' && screenFromUrl.screen !== 'reset-password') {
            console.log('🔗 [AppNavigator] Deep link detected with existing business, navigating to:', screenFromUrl.screen);
            
            if (screenFromUrl.screen === 'conversation' && screenFromUrl.params?.id) {
              setCurrentConversationId(screenFromUrl.params.id);
              navigateTo(screenFromUrl.screen as Screen, screenFromUrl.params.id);
            } else if ((screenFromUrl.screen === 'products' || screenFromUrl.screen === 'products-list' || 
                       screenFromUrl.screen === 'product-create' || 
                       screenFromUrl.screen === 'product-bulk-import')) {
              const catalogueId = screenFromUrl.params?.catalogueId || 'default';
              setCurrentProductParam(catalogueId);
              const targetScreen = screenFromUrl.screen === 'products' ? 'products-list' : screenFromUrl.screen;
              navigateTo(targetScreen as Screen, catalogueId);
            } else if ((screenFromUrl.screen === 'product-detail' || screenFromUrl.screen === 'product-edit') && 
                       screenFromUrl.params?.productId) {
              setCurrentProductParam(screenFromUrl.params.productId);
              navigateTo(screenFromUrl.screen as Screen, screenFromUrl.params.productId);
            } else if ((screenFromUrl.screen === 'catalogue-detail' || screenFromUrl.screen === 'catalogue-edit' || screenFromUrl.screen === 'add-products-to-catalogue') && 
                       screenFromUrl.params?.catalogueId) {
              setCurrentProductParam(screenFromUrl.params.catalogueId);
              navigateTo(screenFromUrl.screen as Screen, screenFromUrl.params.catalogueId);
            } else if ((screenFromUrl.screen === 'quick-reply-set-detail' || screenFromUrl.screen === 'quick-reply-set-edit' || screenFromUrl.screen === 'quick-reply-set-items' || screenFromUrl.screen === 'quick-reply-item-create') && 
                       screenFromUrl.params?.setId) {
              setCurrentProductParam(screenFromUrl.params.setId);
              navigateTo(screenFromUrl.screen as Screen, screenFromUrl.params.setId);
            } else if (screenFromUrl.screen === 'quick-reply-item-edit' && screenFromUrl.params?.itemId) {
              setCurrentProductParam(screenFromUrl.params.itemId);
              navigateTo(screenFromUrl.screen as Screen, screenFromUrl.params.itemId);
            } else if (screenFromUrl.screen === 'shipping-method-edit' && screenFromUrl.params?.methodId) {
              setCurrentProductParam(screenFromUrl.params.methodId);
              navigateTo(screenFromUrl.screen as Screen, screenFromUrl.params.methodId);
            } else if (screenFromUrl.screen === 'flow-edit' && screenFromUrl.params?.flowId) {
              setCurrentProductParam(screenFromUrl.params.flowId);
              navigateTo(screenFromUrl.screen as Screen, screenFromUrl.params.flowId);
            } else if ((screenFromUrl.screen === 'data-list-schema-edit' || screenFromUrl.screen === 'data-list-records') &&
                       screenFromUrl.params?.id) {
              setCurrentProductParam(screenFromUrl.params.id);
              navigateTo(screenFromUrl.screen as Screen, screenFromUrl.params.id);
            } else if (screenFromUrl.screen === 'data-list-record-create' && screenFromUrl.params?.listId) {
              navigateTo(screenFromUrl.screen as Screen, undefined, screenFromUrl.params);
            } else if (screenFromUrl.screen === 'data-list-record-edit' &&
                       screenFromUrl.params?.listId && screenFromUrl.params?.recordId) {
              setCurrentProductParam(screenFromUrl.params.recordId);
              navigateTo(screenFromUrl.screen as Screen, screenFromUrl.params.recordId, screenFromUrl.params);
            } else if ((screenFromUrl.screen === 'visit-detail' || screenFromUrl.screen === 'visit-execute') &&
                       screenFromUrl.params?.visitId) {
              navigateTo(screenFromUrl.screen as Screen, undefined, screenFromUrl.params);
            } else if (screenFromUrl.screen === 'visit-campaign-detail' && screenFromUrl.params?.campaignId) {
              navigateTo(screenFromUrl.screen as Screen, undefined, screenFromUrl.params);
            } else {
              navigateTo(screenFromUrl.screen as Screen);
            }
            return;
          }
        }

        // No deep link, redirect to home
        navigateTo('home');
        return;
      }

      // First check if the current token has business context
      if (tokens?.token) {
        try {
          // Decode JWT token to check for business context
          const tokenPayload = JSON.parse(decodeBase64Url(tokens.token.split('.')[1]));
          
          if (tokenPayload.businessId && tokenPayload.businessRole) {
            console.log('✅ [AppNavigator] Found business in token:', tokenPayload.businessId);
            
            // Create business object from token payload
            const businessFromToken = {
              _id: tokenPayload.businessId,
              name: tokenPayload.businessName || 'Business',
              email: tokenPayload.businessEmail || '',
              isVerified: false,
              members: [],
              departments: [],
              status: 1, // 1 = active
              createdAt: new Date().toISOString(),
              updatedAt: new Date().toISOString()
            } as Business;
            
            // Set the business in the store
            setCurrentBusiness(businessFromToken);
            
            // Token has business context, check for deep links before redirecting
            if (Platform.OS === 'web') {
              const path = window.location.pathname;
              const screenFromUrl = getScreenFromPath(path);
              
              if (screenFromUrl.screen && screenFromUrl.screen !== 'welcome' && screenFromUrl.screen !== 'login' && screenFromUrl.screen !== 'register' && screenFromUrl.screen !== 'otp-verification' && screenFromUrl.screen !== 'forgot-password' && screenFromUrl.screen !== 'reset-password') {
                // Navigate to the deep linked screen instead of home
                console.log('🔗 [AppNavigator] Deep link detected during token business check, navigating to:', screenFromUrl.screen);
                
                // Handle conversation deep link with ID
                if (screenFromUrl.screen === 'conversation' && screenFromUrl.params?.id) {
                  setCurrentConversationId(screenFromUrl.params.id);
                  navigateTo(screenFromUrl.screen as Screen, screenFromUrl.params.id);
                } else {
                  navigateTo(screenFromUrl.screen as Screen);
                }
                return;
              }
            }
            
            // No deep link, redirect to home
            navigateTo('home');
            return;
          } else {
            console.log('⚠️ [AppNavigator] No business context in token');
          }
        } catch (tokenError) {
          console.error('❌ [AppNavigator] Error decoding token:', tokenError);
        }
      }
      
      // If no business context in token, check API using store method
      try {
        const hasUserBusinesses = await checkUserBusinesses();
        
        if (hasUserBusinesses) {
          // User has businesses, check for deep links before redirecting
          if (Platform.OS === 'web') {
            const path = window.location.pathname;
            const screenFromUrl = getScreenFromPath(path);
            
            if (screenFromUrl.screen && screenFromUrl.screen !== 'welcome' && screenFromUrl.screen !== 'login' && screenFromUrl.screen !== 'register' && screenFromUrl.screen !== 'otp-verification' && screenFromUrl.screen !== 'forgot-password' && screenFromUrl.screen !== 'reset-password') {
              // Navigate to the deep linked screen instead of home
              console.log('🔗 [AppNavigator] Deep link detected during business check, navigating to:', screenFromUrl.screen);
              
              // Handle conversation deep link with ID
              if (screenFromUrl.screen === 'conversation' && screenFromUrl.params?.id) {
                setCurrentConversationId(screenFromUrl.params.id);
                navigateTo(screenFromUrl.screen as Screen, screenFromUrl.params.id);
              } else {
                navigateTo(screenFromUrl.screen as Screen);
              }
              return;
            }
          }
          
          // No deep link, redirect to home
          navigateTo('home');
        } else {
          // User has no businesses, redirect to business setup
          navigateTo('business-setup');
        }
      } catch (error: any) {
        console.error('❌ [AppNavigator] Error checking businesses:', error);
        
        // Check if this is an authentication error
        const errorMessage = error?.message || error?.toString() || '';
        const isAuthError = errorMessage.includes('Authentication failed') || 
                           errorMessage.includes('token expired') ||
                           errorMessage.includes('Please login again') ||
                           errorMessage.includes('Unauthorized');
        
        if (isAuthError) {
          // Authentication failed - clear state and redirect to login
          console.log('🔄 [AppNavigator] Authentication error detected, logging out and redirecting to login');
          storeLogout();
          apiService.setAuthToken(null);
          apiService.setRefreshToken(null);
          navigateTo('unified-login');
        } else {
          // Other error, redirect to business setup as fallback
          console.log('⚠️ [AppNavigator] Non-auth error, redirecting to business setup');
          navigateTo('business-setup');
        }
      }
    }
  }, [isAuthenticated, tokens, user, currentScreen, isNavigating, isBusinessLoading, checkUserBusinesses, navigateTo, currentBusiness, hasBusiness, setCurrentBusiness, setCurrentConversationId]);

  // Global validation guard - checks token, business, and subscription
  const validateUserAccess = useCallback(async () => {
    // Always get fresh tokens from store, not from closure
    const freshStore = useAppStore.getState();
    const freshTokens = freshStore.tokens;
    const freshUser = freshStore.user;
    
    if (!freshStore.isAuthenticated || !freshTokens?.token || !freshUser) return;

    // Skip validation for onboarding screens and payment screen
    const onboardingScreens = ['welcome', 'login', 'register', 'otp-verification',
                               'forgot-password', 'reset-password', 'business-setup', 'subscription', 'payment',
                               // Unified onboarding flow (phone/email/social login → business
                               // picker/creation → plan selection → channel stepper) — none of
                               // these have a business/subscription yet by design, so this
                               // token-validation guard must not force-redirect away from them
                               // (it previously did, bouncing plan-selection into the old,
                               // payment-driven `subscription` screen mid-flow).
                               'unified-login', 'business-picker', 'business-creation-wizard',
                               'plan-selection', 'billing-return', 'channel-onboarding-stepper'];
    
    if (onboardingScreens.includes(currentScreen)) {
      console.log('✅ [AppNavigator] On onboarding screen, skipping validation');
      return;
    }

    try {
      // Step 1: Check token expiration - READ FRESH TOKEN FROM STORE
      const tokenPayload = JSON.parse(decodeBase64Url(freshTokens.token.split('.')[1]));
      console.log('🔍 [AppNavigator - validateUserAccess] Full token payload:', JSON.stringify(tokenPayload, null, 2));
      
      const expirationTime = tokenPayload.exp * 1000;
      const currentTime = Date.now();
      const timeUntilExpiration = expirationTime - currentTime;
      const fiveMinutes = 5 * 60 * 1000; // 5 minutes in milliseconds
      
      // If token is expired or will expire in less than 5 minutes, try to refresh
      if (currentTime >= expirationTime || timeUntilExpiration < fiveMinutes) {
        console.log('🔄 [AppNavigator] Token expired or expiring soon, attempting refresh...', {
          expired: currentTime >= expirationTime,
          timeUntilExpiration: timeUntilExpiration,
          expirationTime,
          currentTime
        });
        
        try {
          // Try to refresh token using token manager
          const { tokenManager } = await import('../services/token-manager');
          const refreshResult = await tokenManager.refreshTokens();
          
          if (refreshResult) {
            console.log('✅ [AppNavigator] Token refreshed successfully');
            // Token manager callback will update the store automatically
            // Continue with validation using the refreshed token
            const updatedStore = useAppStore.getState();
            if (updatedStore.tokens?.token) {
              // Re-validate with new token
              const newTokenPayload = JSON.parse(decodeBase64Url(updatedStore.tokens.token.split('.')[1]));
              const newExpirationTime = newTokenPayload.exp * 1000;
              if (Date.now() >= newExpirationTime) {
                // Still expired after refresh (shouldn't happen, but handle it)
                console.error('❌ [AppNavigator] Token still expired after refresh');
                storeLogout();
                setNotification({ 
                  visible: true, 
                  type: 'warning', 
                  title: 'Session Expired', 
                  message: 'Your session has expired. Please login again.' 
                });
                navigateTo('unified-login');
                return;
              }
              // Token is now valid, continue with validation
              console.log('✅ [AppNavigator] Using refreshed token for validation');
            } else {
              throw new Error('No token after refresh');
            }
          } else {
            throw new Error('Token refresh returned null');
          }
        } catch (refreshError: any) {
          console.error('❌ [AppNavigator] Token refresh failed:', refreshError);
          console.log('❌ [AppNavigator] Logging out due to refresh failure');
          storeLogout();
          setNotification({ 
            visible: true, 
            type: 'warning', 
            title: 'Session Expired', 
            message: 'Your session has expired. Please login again.' 
          });
          navigateTo('unified-login');
          return;
        }
      }

      // Step 2: Check if user has at least one business
      if (!tokenPayload.businessId) {
        console.log('❌ [AppNavigator] No business found');
        console.log('🔍 [AppNavigator] businessId in token:', tokenPayload.businessId);
        
        // On iOS, show message instead of redirecting to business-setup
        if (Platform.OS === 'ios') {
          setNotification({
            visible: true,
            type: 'info',
            title: 'Business Account Required',
            message: 'A business account is required. You can log in to your existing account using this app.',
          });
          // Stay on current screen or go to home if possible
          if (currentScreen === 'business-setup' || currentScreen === 'register') {
            navigateTo('unified-login');
          }
        } else {
          navigateTo('business-setup');
        }
        return;
      }

      // Step 3: Check if user has active subscription - check both root subscriptionId and nested subscription.id
      const hasSubscription = tokenPayload.subscriptionId || tokenPayload.subscription?.id;
      if (!hasSubscription) {
        console.log('⚠️ [AppNavigator] No subscription found');
        console.log('🔍 [AppNavigator] subscriptionId in token:', tokenPayload.subscriptionId);
        console.log('🔍 [AppNavigator] subscription object in token:', tokenPayload.subscription);
        
        // No plan yet (e.g. the app was closed right after creating the
        // business): resume onboarding at plan selection. Works on iOS too —
        // free plans and trials need no payment.
        if (currentScreen !== 'plan-selection' && currentScreen !== 'subscription') {
          navigateTo('plan-selection');
        }
        return;
      }

      console.log('✅ [AppNavigator] All validations passed');
      console.log('✅ [AppNavigator] businessId:', tokenPayload.businessId);
      console.log('✅ [AppNavigator] subscriptionId:', tokenPayload.subscriptionId || tokenPayload.subscription?.id);
    } catch (error) {
      console.error('❌ [AppNavigator] Validation error:', error);
      // If validation fails, log out for safety
      storeLogout();
      navigateTo('unified-login');
    }
  }, [currentScreen, storeLogout, navigateTo, setNotification]);

  // Run validation on screen change for protected screens
  useEffect(() => {
    // Delay to ensure token updates have fully propagated through the store
    const validationTimer = setTimeout(() => {
      validateUserAccess();
    }, 300); // Increased delay to prevent race conditions with token updates
    
    return () => clearTimeout(validationTimer);
  }, [currentScreen, validateUserAccess]);

  // Check authentication status on mount and when tokens change
  useEffect(() => {
    const checkAuthStatus = async () => {
      console.log('🔐 [AppNavigator] Checking auth status:', {
        isAuthenticated,
        hasToken: !!tokens?.token,
        hasUser: !!user,
        currentScreen
      });

      // The unified onboarding flow calls setTokens() mid-flow (e.g. PlanSelectionScreen
      // applies the fresh subscription-bearing token immediately instead of waiting for next
      // login) — that alone re-triggers this effect via the `tokens` dependency below. Without
      // this guard, landing on channel-onboarding-stepper (or any other onboarding screen)
      // right after such a token update could fall through this effect's "no deep link, go to
      // home" branches and silently bounce the user to Home before the stepper ever renders.
      const onboardingScreensForAuthCheck: Screen[] = [
        'welcome', 'login', 'register', 'otp-verification', 'forgot-password', 'reset-password',
        'unified-login', 'business-picker', 'business-creation-wizard',
        'plan-selection', 'channel-onboarding-stepper',
      ];
      if (onboardingScreensForAuthCheck.includes(currentScreen) && currentScreen !== 'welcome') {
        console.log('🎯 [AppNavigator] On onboarding screen, skipping auth/business redirect check:', currentScreen);
        return;
      }

      if (isAuthenticated && tokens?.token && user) {
        console.log('✅ [AppNavigator] User is authenticated, checking business status');
        console.log('🔍 [AppNavigator] Current screen:', currentScreen);
        
        // Check business status only if on welcome screen
        // This prevents automatic redirect when user is on login screen
        if (currentScreen === 'welcome') {
          console.log('🏢 [AppNavigator] On welcome screen, checking business status');
          await checkBusinessStatus();
        } else {
          console.log('🎯 [AppNavigator] Not on welcome screen, skipping business check. Current screen:', currentScreen);
        }
      } else if (tokens?.token && !user) {
        // Has token but no user data, validate token and get user profile
        try {
          setLoading(true);
          const profileResponse = await apiService.getProfile(tokens.token);
          
          if (profileResponse.statusCode === 1000 && profileResponse.data) {
            // Token is valid, set user data
            // Normalize the response data to handle _id -> id and ensure mobile/phone fields
            const userData = profileResponse.data;
            const normalizedUser = {
              ...userData,
              id: userData.id || userData._id,
              mobile: userData.mobile || userData.phone,
              phone: userData.phone || userData.mobile,
            };
            // Remove _id if it exists
            if ((normalizedUser as any)._id && normalizedUser.id) {
              delete (normalizedUser as any)._id;
            }
            setUser(normalizedUser);
            
            // Note: Business relationship check moved to the main auth flow above
            // This ensures we check businesses through the BusinessUser table
            
            // Only redirect to home if they're on an auth screen
            if (currentScreen === 'welcome' || currentScreen === 'login' || currentScreen === 'register' || currentScreen === 'otp-verification' || currentScreen === 'forgot-password' || currentScreen === 'reset-password') {
              // Check if there's a deep link in the URL
              if (Platform.OS === 'web') {
                const path = window.location.pathname;
                const routeResult = getScreenFromPath(path);
                
                if (routeResult.screen && routeResult.screen !== 'welcome' && routeResult.screen !== 'login' && routeResult.screen !== 'register' && routeResult.screen !== 'otp-verification' && routeResult.screen !== 'forgot-password' && routeResult.screen !== 'reset-password') {
                  // Handle conversation deep link
                  if (routeResult.screen === 'conversation' && routeResult.params.id) {
                    setCurrentConversationId(routeResult.params.id);
                    navigateTo(routeResult.screen as Screen, routeResult.params.id);
                  } else if ((routeResult.screen === 'products' || routeResult.screen === 'products-list' || 
                             routeResult.screen === 'product-create' || 
                             routeResult.screen === 'product-bulk-import')) {
                    const catalogueId = routeResult.params?.catalogueId || 'default';
                    setCurrentProductParam(catalogueId);
                    const targetScreen = routeResult.screen === 'products' ? 'products-list' : routeResult.screen;
                    navigateTo(targetScreen as Screen, catalogueId);
                  } else if ((routeResult.screen === 'product-detail' || routeResult.screen === 'product-edit') && 
                             routeResult.params.productId) {
                    setCurrentProductParam(routeResult.params.productId);
                    navigateTo(routeResult.screen as Screen, routeResult.params.productId);
                  } else if (routeResult.screen === 'event-create') {
                    // Handle event-create with or without calendarId
                    if (routeResult.params?.calendarId) {
                      setCurrentProductParam(routeResult.params.calendarId);
                    }
                    setRouteParams(routeResult.params || {});
                    navigateTo(routeResult.screen as Screen, routeResult.params?.calendarId, routeResult.params);
                  } else if (routeResult.screen === 'event-edit') {
                    // Handle event-edit with or without eventId
                    if (routeResult.params?.eventId) {
                      setCurrentProductParam(routeResult.params.eventId);
                    }
                    setRouteParams(routeResult.params || {});
                    navigateTo(routeResult.screen as Screen, routeResult.params?.eventId, routeResult.params);
                  } else if (routeResult.screen === 'business-calendar') {
                    // Handle business-calendar with or without calendarId
                    if (routeResult.params?.calendarId) {
                      setCurrentProductParam(routeResult.params.calendarId);
                    }
                    setRouteParams(routeResult.params || {});
                    navigateTo(routeResult.screen as Screen, routeResult.params?.calendarId, routeResult.params);
                  } else if (routeResult.screen === 'calendars') {
                    setRouteParams(routeResult.params || {});
                    navigateTo(routeResult.screen as Screen, undefined, routeResult.params);
                  } else {
                    // Navigate to the deep linked screen instead of home
                    setRouteParams(routeResult.params || {});
                    navigateTo(routeResult.screen as Screen, undefined, routeResult.params);
                  }
                  return;
                }
              }
              // No deep link, go to home
              navigateTo('home');
            }
          } else {
            // Token is invalid, clear auth
            storeLogout();
            navigateTo('welcome');
          }
        } catch (error) {
          storeLogout();
          navigateTo('welcome');
        } finally {
          setLoading(false);
        }
      }
    };

    checkAuthStatus();
  }, [tokens, user, isAuthenticated, currentScreen, isNavigating, checkBusinessStatus, setUser, setLoading, storeLogout]);

  const showNotification = (type: 'success' | 'error' | 'info' | 'warning' | 'message', title: string, message: string) => {
    setNotification({ visible: true, type, title, message });
  };

  const showClickableNotification = (type: 'success' | 'error' | 'info' | 'warning' | 'message', title: string, message: string, action?: { label: string; onPress: () => void; channel?: string; channelName?: string; data?: Record<string, any> }) => {
    setNotification({ visible: true, type, title, message, action });
  };

  const hideNotification = () => {
    setNotification({ ...notification, visible: false });
  };

  // Navigation function definitions
  const handleGetStarted = () => navigateTo('unified-login');
  const handleForgotPassword = () => navigateTo('forgot-password');
  const handleSignUp = () => navigateTo('register');
  const handleBackToLogin = () => navigateTo('unified-login');
  const handleBackToWelcome = () => navigateTo('welcome');
  const handleBackToRegister = () => navigateTo('register');
  const handleLogout = async () => {
    console.log('🔄 [AppNavigator] Logging out...');
    console.log('📱 [AppNavigator] FCM token will remain active for this user');
    console.log('📱 [AppNavigator] User will still receive notifications until someone else logs in');
    
    // Check if user had remember-me enabled before clearing state
    const { loadCredentials } = await import('../utils/credentialManager');
    const hadRememberedCredentials = await loadCredentials();
    console.log('🔐 [AppNavigator] User had remembered credentials:', !!hadRememberedCredentials);
    
    // IMPORTANT: We preserve remember-me credentials even on explicit logout
    // This matches web behavior - credentials persist until user manually unchecks remember-me
    // The credentials are only cleared when user logs in without remember-me checked
    
    // IMPORTANT: We DON'T unregister or clear the FCM token here!
    // This allows the logged-out user to still receive notifications.
    // When a new user logs in, their registration will update the token ownership.
    
    fcmService.clearUserRegistration(); // Just clear local tracking
    storeLogout();
    navigateTo('welcome');
  };
  const handleWhatsAppTest = () => navigateTo('whatsapp-test');
  
  const handleChatNavigation = () => navigateTo('chat');
  
  const handleConversationNavigation = (conversationId: string) => {
    // Handle special case for inbox navigation
    if (conversationId === 'inbox') {
      navigateTo('chat');
      return;
    }

    // Ensure conversationId is a string
    const idString = String(conversationId);
    console.log('🔍 [AppNavigator] Setting conversation ID:', idString);
    setCurrentConversationId(idString);

    // Navigate to conversation with the ID directly
    console.log('🔍 [AppNavigator] Navigating to conversation with ID:', idString);
    navigateTo('conversation', idString);
  };

  const handleSocialLogin = (provider: 'google' | 'facebook' | 'apple') => {
    // Social login functionality - users can register/login with email and password
    // Social login integration is in progress
    const isOnRegisterScreen = currentScreen === 'register';
    showNotification('info', 'Social Login', `Please use email and password to ${isOnRegisterScreen ? 'register' : 'login'}. Social login integration is in progress.`);
    if (isOnRegisterScreen) {
      // Stay on register screen
      return;
    }
    navigateTo('unified-login');
  };

  // Initialize notification service and global socket setup
  useEffect(() => {
    const isCurrentScreenChat = () => currentScreen === 'chat';
    const getCurrentBusinessId = () => currentBusiness?._id;
    notificationService.setNotificationHandler(showClickableNotification, handleConversationNavigation, isCurrentScreenChat, getCurrentBusinessId);
  }, [showClickableNotification, handleConversationNavigation, currentScreen, currentBusiness?._id]);

  // Handle browser navigation (back/forward buttons) for web platform
  useEffect(() => {
    if (Platform.OS === 'web') {
      const handlePopState = () => {
        const path = window.location.pathname;
        const routeResult = getScreenFromPath(path);
        
        if (routeResult.screen) {
          // Handle conversation deep link
          if (routeResult.screen === 'conversation' && routeResult.params.id) {
            setCurrentConversationId(routeResult.params.id);
          } else if (routeResult.screen !== 'conversation') {
            // Clear conversation ID if navigating away from conversation
            setCurrentConversationId('');
          }
          
          // Handle product screen deep links
          if ((routeResult.screen === 'products' || routeResult.screen === 'products-list' || 
               routeResult.screen === 'product-create' || 
               routeResult.screen === 'product-bulk-import')) {
            const catalogueId = routeResult.params?.catalogueId || 'default';
            setCurrentProductParam(catalogueId);
            const targetScreen = routeResult.screen === 'products' ? 'products-list' : routeResult.screen;
            navigateTo(targetScreen as Screen, catalogueId);
          } else if ((routeResult.screen === 'product-detail' || routeResult.screen === 'product-edit') && 
                     routeResult.params.productId) {
            setCurrentProductParam(routeResult.params.productId);
            navigateTo(routeResult.screen as Screen, routeResult.params.productId);
          } else if (routeResult.screen === 'event-create' && routeResult.params.calendarId) {
            // Handle event-create with calendarId
            setCurrentProductParam(routeResult.params.calendarId);
            setRouteParams(routeResult.params);
            navigateTo(routeResult.screen as Screen, routeResult.params.calendarId, routeResult.params);
          } else if (routeResult.screen === 'event-edit' && routeResult.params.eventId) {
            // Handle event-edit with eventId
            setCurrentProductParam(routeResult.params.eventId);
            setRouteParams(routeResult.params);
            navigateTo(routeResult.screen as Screen, routeResult.params.eventId, routeResult.params);
          } else if (routeResult.screen === 'department-edit' && routeResult.params.departmentId) {
            // Handle department-edit with departmentId
            setCurrentProductParam(routeResult.params.departmentId);
            setRouteParams(routeResult.params);
            navigateTo(routeResult.screen as Screen, routeResult.params.departmentId, routeResult.params);
          } else if (routeResult.screen === 'business-calendar') {
            // Handle business-calendar with or without calendarId
            if (routeResult.params?.calendarId) {
              setCurrentProductParam(routeResult.params.calendarId);
            }
            setRouteParams(routeResult.params || {});
            navigateTo(routeResult.screen as Screen, routeResult.params?.calendarId, routeResult.params);
          } else if (routeResult.screen === 'calendars') {
            setRouteParams(routeResult.params || {});
            navigateTo(routeResult.screen as Screen, undefined, routeResult.params);
          } else {
            setRouteParams(routeResult.params || {});
            navigateTo(routeResult.screen as Screen, undefined, routeResult.params);
          }
        }
      };

      window.addEventListener('popstate', handlePopState);
      return () => window.removeEventListener('popstate', handlePopState);
    }
  }, [navigateTo, setCurrentConversationId]);

  // Coalesces bursts of contacts/assignments refresh triggers into a single refresh
  // after things settle, instead of one full contact-list re-fetch per event. Without
  // this, a bulk WhatsApp send that creates many new contacts fires one
  // `new_assignment` socket notification PER new contact (each new contact
  // auto-creates an assignment task — see whatsapp-contact.service.ts), so a send to
  // hundreds of new numbers was triggering hundreds of full-list re-fetches within
  // seconds, which is what made the contacts screen "super bad" regardless of how
  // well-optimized ContactsList itself is internally.
  const refreshDebounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const scheduleContactsAndConversationsRefresh = useCallback(() => {
    if (refreshDebounceTimerRef.current) {
      clearTimeout(refreshDebounceTimerRef.current);
    }
    refreshDebounceTimerRef.current = setTimeout(() => {
      bumpContactsRefreshToken();
      bumpConversationsRefreshToken();
      refreshDebounceTimerRef.current = null;
    }, 1500);
  }, [bumpContactsRefreshToken, bumpConversationsRefreshToken]);

  // Global socket and FCM setup for notifications (always active)
  useEffect(() => {
    const handleSocketNotification = (notificationData: any) => {
      console.log('🔔 [AppNavigator] Socket.IO notification received:', notificationData);

      const payload = notificationData?.data || {};
      const assignmentNotificationType = notificationData?.type || payload?.type;
      const action = payload?.action || notificationData?.action;
      if (
        payload?.reloadContacts ||
        payload?.reloadAssignments ||
        action === 'removed' ||
        assignmentNotificationType === 'new_assignment' ||
        assignmentNotificationType === 'assignment_update'
      ) {
        scheduleContactsAndConversationsRefresh();
      }

      // The server writes title/body in the user's language; the banner
      // shows them as they are (type decides the icon/colour there).
      showClickableNotification(
        'message',
        notificationData.title || '',
        notificationData.body || '',
        {
          label: '',
          onPress: () => { openNotificationTarget(navigateToRef.current, notificationData.clickAction, notificationData.data); },
          channel: notificationData.type,
          channelName: '',
          data: notificationData.data,
        }
      );

      // Refresh notification badge count
      console.log('🔔 [AppNavigator] Socket.IO notification processed');
    };

    const setupGlobalServices = async () => {
      try {
        console.log('🔔 [AppNavigator] ===== SETTING UP GLOBAL SERVICES =====');
        console.log('🔔 [AppNavigator] Platform:', Platform.OS);
        console.log('🔔 [AppNavigator] Is authenticated:', isAuthenticated);
        console.log('🔔 [AppNavigator] User exists:', !!user);
        
        // Connect to socket service only when authenticated (non-blocking: app works without real-time)
        if (isAuthenticated && user) {
          // Keep-alive (not a one-shot connect): retries a failed first
          // connect in the background and reconnects whenever the app
          // returns to the foreground — iOS drops sockets when backgrounded.
          console.log('🔔 [AppNavigator] Starting Socket.IO keep-alive...');
          socketService.startKeepAlive();
        } else {
          console.log('🔔 [AppNavigator] Skipping Socket.IO (not authenticated)');
        }
        
        // Initialize FCM service
        console.log('🔔 [AppNavigator] Initializing FCM service...');
        await fcmService.initialize();
        console.log('✅ [AppNavigator] FCM initialization complete');
        
        // Set up notification click handler for FCM notifications
        console.log('🔔 [AppNavigator] Setting up FCM notification click handler...');
        fcmService.setNavigationHandler(async (notification) => {
          await openNotificationTarget(navigateToRef.current, notification.clickAction, notification.data);
        });
        console.log('✅ [AppNavigator] FCM notification click handler configured');
        
        // Set up Socket.IO notification listener for in-app notifications
        console.log('🔔 [AppNavigator] Setting up Socket.IO notification listener...');
        socketService.on('app-notification', handleSocketNotification);
        console.log('✅ [AppNavigator] Socket.IO notification listener configured');
        
        // Register FCM token if user is authenticated (with auth error handler)
        if (isAuthenticated && user) {
          console.log('🔔 [AppNavigator] User authenticated, attempting FCM token registration...');
          const authErrorHandler = () => {
            console.log('🔄 [AppNavigator] Initial FCM auth error - logging out');
            storeLogout();
            apiService.setAuthToken(null);
            apiService.setRefreshToken(null);
            socketService.stopKeepAlive();
      socketService.disconnect();
            setNotification({
              visible: true,
              type: 'error',
              title: 'Session Expired',
              message: 'Your session has expired. Please login again.',
            });
            setCurrentScreen('unified-login');
            if (Platform.OS === 'web') {
              window.history.pushState({}, '', '/unified-login');
            }
          };
          await fcmService.registerToken(authErrorHandler);
        } else {
          console.log('⚠️ [AppNavigator] User not authenticated, skipping FCM token registration');
        }
        console.log('✅ [AppNavigator] ===== GLOBAL SERVICES SETUP COMPLETE =====');
      } catch (error) {
        console.error('❌ [AppNavigator] ===== FAILED TO SETUP GLOBAL SERVICES =====');
        console.error('❌ [AppNavigator] Error:', error);
        console.error('❌ [AppNavigator] Error message:', error.message);
        console.error('❌ [AppNavigator] Error stack:', error.stack);
      }
    };

    setupGlobalServices();
    
    // Cleanup
    return () => {
      console.log('🧹 [AppNavigator] Cleaning up Socket.IO listeners...');
      socketService.off('app-notification', handleSocketNotification);
    };
  }, []); // Only run once on app start

  // Register FCM token when user authenticates
  useEffect(() => {
    const registerFCMToken = async () => {
      console.log('🔔 [AppNavigator] ===== AUTH STATUS CHANGED =====');
      console.log('🔔 [AppNavigator] Is authenticated:', isAuthenticated);
      console.log('🔔 [AppNavigator] User exists:', !!user);
      
      if (isAuthenticated && user) {
        try {
          console.log('🔔 [AppNavigator] User authenticated, registering FCM token...');
          
          // Pass auth error handler to FCM service
          const authErrorHandler = () => {
            console.log('🔄 [AppNavigator] FCM auth error - logging out and redirecting to login');
            storeLogout();
            apiService.setAuthToken(null);
            apiService.setRefreshToken(null);
            socketService.stopKeepAlive();
      socketService.disconnect();
            setNotification({
              visible: true,
              type: 'error',
              title: 'Session Expired',
              message: 'Your session has expired. Please login again.',
            });
            setCurrentScreen('unified-login');
            if (Platform.OS === 'web') {
              window.history.pushState({}, '', '/unified-login');
            }
          };
          
          // The API stores a token only once the session carries a business
          // (it answers 401 MISSING_USER_CONTEXT otherwise), and iOS can take
          // a while to mint the FCM token — so retry with backoff instead of
          // giving up after one attempt. This effect also re-runs when the
          // business changes (see deps), which covers registering right
          // after the business is picked.
          // The run-once app-start setup only starts the socket when the app
          // launched already signed in — a sign-in during the session needs
          // it started here too (startKeepAlive is idempotent).
          socketService.startKeepAlive();

          const retryDelays = [0, 5000, 15000, 45000];
          for (const delay of retryDelays) {
            if (cancelled) return;
            if (delay) await new Promise((resolve) => setTimeout(resolve, delay));
            if (cancelled) return;
            const success = await fcmService.registerToken(authErrorHandler, true);
            console.log(`🔔 [AppNavigator] FCM token registration ${success ? 'succeeded' : 'failed'} (attempt after ${delay}ms)`);
            if (success) break;
          }
        } catch (error) {
          console.error('❌ [AppNavigator] Failed to register FCM token:', error);
          console.error('❌ [AppNavigator] Error message:', error.message);
        }
      } else {
        console.log('⚠️ [AppNavigator] Not authenticated or no user, skipping FCM registration');
      }
    };

    let cancelled = false;
    registerFCMToken();
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, user?.id, currentBusiness?._id, storeLogout, setCurrentScreen, setNotification]); // Run on sign-in and whenever the active business changes

  // Phone channel — headless InnoCalls dialer, initialized once here so it
  // survives screen navigation (the hook itself no-ops if the phone channel
  // isn't connected/configured for this business or agent).
  // Only once signed in: on public pages (catalog/checkout links opened by
  // customers) the dialer's credential fetches ran with no token and fired
  // the global auth-error redirect, bouncing visitors to the login screen.
  const phoneDialer = usePhoneDialer(isAuthenticated);
  const isMobileBrowserForCallUI = useIsMobileBrowser();

  // Native calling — InnoCalls' WebRTC dialer is a browser-only SDK
  // (window.RTCPeerConnection, document script injection) that genuinely
  // cannot run inside React Native's JS environment, so usePhoneDialer
  // itself is a no-op on native (see its own isSupportedPlatform check).
  // Instead of leaving native calling entirely unavailable, this opens the
  // SAME PhoneCallScreen experience in an IN-APP WebView modal (not an
  // external browser tab — confirmed real UX gap: leaving the app entirely
  // for a call broke the sense of staying "inside" Sendifier, and offered
  // no way back except the OS's own browser-tab close), pointed at a new
  // minimal, standalone web route (CallScreen.tsx) that re-authenticates
  // itself from the token passed here. The token is this app's own existing
  // session JWT — every API call that page makes runs through the SAME
  // per-user authorization checks (contact access scope, business
  // membership, etc.) as anywhere else in the app; nothing here bypasses or
  // duplicates that logic, it only carries the credential that makes the
  // existing checks evaluate as this same logged-in agent.
  const startNativePhoneCall = async (
    phoneNumber: string,
    contactId?: string,
    displayInfo?: { name: string; avatar?: string; linkedChannels?: string[] }
  ) => {
    const token = apiService.getAuthToken();
    if (!token) {
      showNotification('error', 'Call Failed', 'You must be signed in to place a call.');
      return;
    }
    // A short-lived, single-use code stands in for the real token in the
    // URL — confirmed real bug: this app's own JWT embeds the full
    // business/subscription/permissions payload and is large enough that
    // putting it directly in the URL produced a URL long enough to make
    // iOS's SFSafariViewController fail with "site can't be reached", even
    // though the target server itself responded fine. See sendifier_api's
    // call-session-code.service.ts.
    const codeRes = await apiService.createCallSessionCode(phoneNumber, contactId, displayInfo?.name);
    if (!codeRes.data?.code) {
      showNotification('error', 'Call Failed', 'Could not start the call. Please try again.');
      return;
    }
    setNativeCallModalUrl(`https://connect.dislix.com/call?code=${codeRes.data.code}`);
  };

  // Context value
  const contextValue: AppContextType = {
    currentScreen,
    navigateTo,
    showNotification,
    showClickableNotification,
    phoneCallState: phoneDialer.callState,
    phoneCallDuration: phoneDialer.duration,
    phoneCallError: phoneDialer.error,
    phoneCallContact: phoneDialer.contact,
    phoneCallMinimized: phoneDialer.minimized,
    setPhoneCallMinimized: phoneDialer.setMinimized,
    // On native, calling never depends on InnoCalls' own web SDK being
    // mounted/ready (that hook is a permanent no-op there, see its own
    // isSupportedPlatform check) — it just opens an in-app browser. Without
    // this platform check, isPhoneDialerReady stayed false forever on
    // native, and ContactsList's own handleCallPress guard silently
    // swallowed every call attempt before startNativePhoneCall was ever
    // reached — confirmed real bug: "nothing happens" when tapping Call
    // was this guard eating the press, not startNativePhoneCall failing.
    isPhoneDialerReady: Platform.OS === 'web' ? phoneDialer.isReady : true,
    startPhoneCall: Platform.OS === 'web' ? phoneDialer.startCall : startNativePhoneCall,
    hangupPhoneCall: phoneDialer.hangup,
    dismissPhoneCall: phoneDialer.dismissCall,
    handleGetStarted,
    handleSignUp,
    handleBackToLogin,
    handleForgotPassword,
    handleBackToWelcome,
    handleBackToRegister,
    handleLogout,
    handleSocialLogin,
    handleWhatsAppTest,
    handleChatNavigation,
    handleConversationNavigation,
    joinConversationRooms,
    // Shared state
    pendingEmail,
    setPendingEmail,
    isNewUser,
    setIsNewUser,
    activeTab,
    setActiveTab,
    routeParams,
  };

  // Render notification component
  const renderNotification = () => {
    
    if (Platform.OS === 'web') {
      // Web: Use fixed positioning container
      return (
        <View style={styles.rootNotificationContainer}>
          <Notification
            visible={notification.visible}
            type={notification.type}
            title={notification.title}
            message={notification.message}
            action={notification.action}
            onClose={hideNotification}
          />
        </View>
      );
    } else {
      // Mobile: Render notification directly without wrapper
      return (
        <Notification
          visible={notification.visible}
          type={notification.type}
          title={notification.title}
          message={notification.message}
          action={notification.action}
          onClose={hideNotification}
        />
      );
    }
  };

  // In-call UI on mobile web: PhoneCallScreen/PhoneCallMinimizedBar are
  // normally hosted inside RightPane, but ScreenLayout only renders panes on
  // desktop web (Platform.OS === 'web' && !isMobileBrowser) — on native or a
  // narrow mobile-web viewport there was no mount point for either at all,
  // so an active call showed no UI whatsoever. Rendered once here (alongside
  // renderNotification, in every switch case below) as a full-screen overlay
  // instead, independent of whatever screen/pane state is active. Native is
  // excluded too since usePhoneDialer only supports web (no SIP details yet
  // for native calling).
  // Every screen renders this: the call overlay plus the app-wide search palette.
  const renderMobileCallOverlay = () => (
    <>
      {renderCallOverlay()}
      <GlobalSearchHost />
    </>
  );

  const renderCallOverlay = () => {
    // Native's own in-app call WebView modal — independent of the web-only
    // branch below, so it renders (or doesn't) regardless of platform
    // checks that only apply to the desktop/mobile-web overlay.
    const nativeCallModal = Platform.OS !== 'web' && nativeCallModalUrl ? (
      <NativePhoneCallModal key={nativeCallModalUrl} url={nativeCallModalUrl} onClose={() => setNativeCallModalUrl(null)} />
    ) : null;

    if (Platform.OS !== 'web' || !isMobileBrowserForCallUI) return nativeCallModal;
    if (phoneDialer.callState === 'idle') return nativeCallModal;

    return (
      <>
        {nativeCallModal}
        {phoneDialer.minimized ? (
          <View style={styles.mobileCallMinimizedContainer}>
            <PhoneCallMinimizedBar />
          </View>
        ) : (
          <View style={styles.mobileCallOverlay}>
            <PhoneCallScreen />
          </View>
        )}
      </>
    );
  };

  // Home/Contacts/Chat share a persistent contacts pane on desktop web —
  // routed through PersistentPaneShell instead of the switch below so the
  // shell's single <ScreenLayout> (and therefore its LeftPane/ContactsList)
  // never remounts while the user moves between just these three screens.
  // See /Users/aydahab.mac/.claude/plans/iterative-squishing-lark.md for the
  // full rationale. Native/narrow mobile-web fall through to the ordinary
  // switch cases below, unchanged — isDesktopPaneLayout is the one shared
  // hook (not computed independently) so this can never disagree with each
  // screen's own copy of the same check.
  const isDesktopPaneLayout = useDesktopPaneLayout();
  const isInShellGroup = isDesktopPaneLayout && ['home', 'contacts', 'chat'].includes(currentScreen);
  // Confirmed real bug in the first version of this: conditionally rendering
  // `{currentScreen === 'chat' && <InboxScreen />}` (i.e. only mounting the
  // ACTIVE screen) meant each screen's own content still fully unmounted and
  // remounted on every switch — only the shared pane (owned by
  // PersistentPaneShell itself) actually persisted, defeating the point for
  // Inbox's conversation list (full refetch + socket listener re-setup every
  // visit), Home's dashboard, and Contacts' own list. Fix: once a screen in
  // this group has been visited, keep it mounted (hidden via display:none,
  // not destroyed) for the rest of the time the user stays in the group —
  // reset back to empty the moment the user leaves the group entirely, so
  // re-entering later (a fresh PersistentPaneShell mount) starts clean
  // rather than resurrecting stale screens from a much earlier visit.
  const [visitedShellScreens, setVisitedShellScreens] = useState<Set<string>>(() => new Set());
  useEffect(() => {
    if (isInShellGroup) {
      setVisitedShellScreens(prev => (prev.has(currentScreen) ? prev : new Set(prev).add(currentScreen)));
    } else {
      setVisitedShellScreens(prev => (prev.size === 0 ? prev : new Set()));
    }
  }, [isInShellGroup, currentScreen]);

  if (isInShellGroup) {
    return (
      <AppContext.Provider value={contextValue}>
        <PersistentPaneShell>
          {visitedShellScreens.has('home') && (
            <View style={{ flex: 1, display: currentScreen === 'home' ? 'flex' : 'none' }}>
              <HomeScreen isActive={currentScreen === 'home'} deepLinkContactId={deepLinkContactId} onDeepLinkContactOpened={clearDeepLinkContact} />
            </View>
          )}
          {visitedShellScreens.has('contacts') && (
            <View style={{ flex: 1, display: currentScreen === 'contacts' ? 'flex' : 'none' }}>
              <ContactsListScreen
                scopedToDataListId={(routeParams as any)?.scopedToDataListId}
                scopedListName={(routeParams as any)?.scopedListName}
                isActive={currentScreen === 'contacts'}
                deepLinkContactId={deepLinkContactId}
                onDeepLinkContactOpened={clearDeepLinkContact}
              />
            </View>
          )}
          {visitedShellScreens.has('chat') && (
            <View style={{ flex: 1, display: currentScreen === 'chat' ? 'flex' : 'none' }}>
              <InboxScreen isActive={currentScreen === 'chat'} deepLinkContactId={deepLinkContactId} onDeepLinkContactOpened={clearDeepLinkContact} />
            </View>
          )}
        </PersistentPaneShell>
        {renderNotification()}
        {renderMobileCallOverlay()}
      </AppContext.Provider>
    );
  }

  // Render screens based on current screen - NO PROPS PASSED
  switch (currentScreen) {
    case 'welcome':
      return (
        <AppContext.Provider value={contextValue}>
          <WelcomeScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'login':
      return (
        <AppContext.Provider value={contextValue}>
          <LoginScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'unified-login':
      return (
        <AppContext.Provider value={contextValue}>
          <UnifiedLoginScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'business-picker':
      return (
        <AppContext.Provider value={contextValue}>
          <BusinessPickerScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'business-creation-wizard':
      return (
        <AppContext.Provider value={contextValue}>
          <BusinessCreationWizardScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'plan-selection':
      return (
        <AppContext.Provider value={contextValue}>
          <PlanSelectionScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'billing-return':
      return (
        <AppContext.Provider value={contextValue}>
          <BillingReturnScreen />
          {renderNotification()}
        </AppContext.Provider>
      );

    case 'billing-addons':
      return (
        <AppContext.Provider value={contextValue}>
          <BillingAddonsScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'channel-onboarding-stepper':
      return (
        <AppContext.Provider value={contextValue}>
          <ChannelOnboardingStepper />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'register':
      return (
        <AppContext.Provider value={contextValue}>
          <RegisterScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'otp-verification':
      return (
        <AppContext.Provider value={contextValue}>
          <OTPVerificationScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'forgot-password':
      return (
        <AppContext.Provider value={contextValue}>
          <ForgotPasswordScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'reset-password':
      return (
        <AppContext.Provider value={contextValue}>
          <ResetPasswordScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'business-setup':
      return (
        <AppContext.Provider value={contextValue}>
          <BusinessSetupScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'home':
      return (
        <AppContext.Provider value={contextValue}>
          <HomeScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'dashboard':
      return (
        <AppContext.Provider value={contextValue}>
          <DashboardScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'dashboard-team-all':
      return (
        <AppContext.Provider value={contextValue}>
          <DashboardTeamAllScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'dashboard-templates-all':
      return (
        <AppContext.Provider value={contextValue}>
          <DashboardTemplatesAllScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'posts-list':
      return (
        <AppContext.Provider value={contextValue}>
          <PostsListScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'post-create':
      return (
        <AppContext.Provider value={contextValue}>
          <PostCreateScreen pageId={(routeParams as any)?.pageId} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'dashboard-flows-all':
      return (
        <AppContext.Provider value={contextValue}>
          <DashboardFlowsAllScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'dashboard-assignments-all':
      return (
        <AppContext.Provider value={contextValue}>
          <DashboardAssignmentsAllScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'social':
      return (
        <AppContext.Provider value={contextValue}>
          <SocialHubScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'performance':
      // Repurposed route: this used to render a hardcoded-mock PerformanceScreen.
      // The screen id/tab wiring ('performance') is left unchanged everywhere else
      // in this file (dozens of navigateTo('performance') call sites across other
      // screens) — only what renders here changed, to the real Reports screen.
      return (
        <AppContext.Provider value={contextValue}>
          <ReportsScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'whatsapp-test':
      return (
        <AppContext.Provider value={contextValue}>
          <WhatsAppTestScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'whatsapp-business-setup':
      return (
        <AppContext.Provider value={contextValue}>
          <WhatsAppBusinessSetupScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'whatsapp-conversation':
      return (
        <AppContext.Provider value={contextValue}>
          <WhatsAppContactScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'send-whatsapp-message':
      return (
        <AppContext.Provider value={contextValue}>
          <SendWhatsAppMessageScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'contacts':
      return (
        <AppContext.Provider value={contextValue}>
          <ContactsListScreen
            scopedToDataListId={(routeParams as any)?.scopedToDataListId}
            scopedListName={(routeParams as any)?.scopedListName}
          />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'bulk-contact-upload':
      return (
        <AppContext.Provider value={contextValue}>
          <BulkContactUploadScreen listId={(routeParams as any)?.listId} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'notifications':
      return (
        <AppContext.Provider value={contextValue}>
          <NotificationHistoryScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'facebook-messenger-setup':
      return (
        <AppContext.Provider value={contextValue}>
          <FacebookMessengerSetupScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'facebook-callback':
      return (
        <AppContext.Provider value={contextValue}>
          <FacebookCallbackScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'x-twitter-setup':
      return (
        <AppContext.Provider value={contextValue}>
          <XTwitterSetupScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'phone-setup':
      return (
        <AppContext.Provider value={contextValue}>
          <PhoneSetupScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'ai-setup':
    case 'ai-usage':
      return (
        <AppContext.Provider value={contextValue}>
          {currentScreen === 'ai-setup' ? <AiSetupScreen /> : <AiUsageScreen />}
          {renderNotification()}
        </AppContext.Provider>
      );

    case 'visits-setup':
      return (
        <AppContext.Provider value={contextValue}>
          <VisitsSetupScreen />
          {renderNotification()}
        </AppContext.Provider>
      );

    case 'visits':
      return (
        <AppContext.Provider value={contextValue}>
          <VisitsListScreen />
          {renderNotification()}
        </AppContext.Provider>
      );

    case 'visit-detail':
      return (
        <AppContext.Provider value={contextValue}>
          <VisitDetailScreen />
          {renderNotification()}
        </AppContext.Provider>
      );

    case 'visit-create':
      return (
        <AppContext.Provider value={contextValue}>
          <VisitCreateScreen />
          {renderNotification()}
        </AppContext.Provider>
      );

    case 'visit-execute':
      return (
        <AppContext.Provider value={contextValue}>
          <VisitExecuteScreen />
          {renderNotification()}
        </AppContext.Provider>
      );

    case 'visit-route':
      return (
        <AppContext.Provider value={contextValue}>
          <VisitRouteScreen />
          {renderNotification()}
        </AppContext.Provider>
      );

    case 'visits-campaigns':
      return (
        <AppContext.Provider value={contextValue}>
          <VisitCampaignsListScreen />
          {renderNotification()}
        </AppContext.Provider>
      );

    case 'visit-campaign-create':
      return (
        <AppContext.Provider value={contextValue}>
          <VisitCampaignCreateScreen />
          {renderNotification()}
        </AppContext.Provider>
      );

    case 'visit-campaign-detail':
      return (
        <AppContext.Provider value={contextValue}>
          <VisitCampaignDetailScreen />
          {renderNotification()}
        </AppContext.Provider>
      );

    case 'visit-campaign-distribute':
      return (
        <AppContext.Provider value={contextValue}>
          <VisitCampaignDistributeScreen />
          {renderNotification()}
        </AppContext.Provider>
      );

    case 'call-history':
      return (
        <AppContext.Provider value={contextValue}>
          <CallHistoryScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'chat':
      return (
        <AppContext.Provider value={contextValue}>
          <InboxScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'conversation':
      return (
        <AppContext.Provider value={contextValue}>
          <ConversationScreen 
            conversationId={currentConversationId} 
            onNavigateBack={handleChatNavigation}
          />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'subscription':
      return (
        <AppContext.Provider value={contextValue}>
          <BillingScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'user-setup':
      return (
        <AppContext.Provider value={contextValue}>
          <UserSetupScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'departments':
      return (
        <AppContext.Provider value={contextValue}>
          <DepartmentsScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'business-permissions':
      return (
        <AppContext.Provider value={contextValue}>
          <BusinessPermissionsScreen
            targetType={(routeParams as any)?.targetType}
            targetId={currentProductParam || (routeParams as any)?.targetId}
            targetIds={(routeParams as any)?.targetIds}
          />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'add-verify-identity':
      return (
        <AppContext.Provider value={contextValue}>
          <AddVerifyIdentityScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'department-add':
      return (
        <AppContext.Provider value={contextValue}>
          <AddDepartmentScreen mode="new" />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'department-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <AddDepartmentScreen 
            mode="edit" 
            departmentId={currentProductParam || (routeParams as any)?.departmentId} 
          />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'invitation-acceptance':
      return (
        <AppContext.Provider value={contextValue}>
          <InvitationAcceptanceScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'payment':
      return (
        <AppContext.Provider value={contextValue}>
          <PaymentScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'task-history':
      return (
        <AppContext.Provider value={contextValue}>
          <TaskHistoryScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'settings':
      return (
        <AppContext.Provider value={contextValue}>
          <SettingsScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'devices':
      return (
        <AppContext.Provider value={contextValue}>
          <DevicesListScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'device-create':
      return (
        <AppContext.Provider value={contextValue}>
          <DeviceCreateScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'device-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <DeviceEditScreen deviceId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'units':
      return (
        <AppContext.Provider value={contextValue}>
          <UnitsListScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'shipping-methods':
      return (
        <AppContext.Provider value={contextValue}>
          <ShippingMethodsScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'shipping-method-create':
      return (
        <AppContext.Provider value={contextValue}>
          <ShippingMethodFormScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'shipping-method-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <ShippingMethodFormScreen methodId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'inventory':
      return (
        <AppContext.Provider value={contextValue}>
          <InventoryScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'business-profile':
      return (
        <AppContext.Provider value={contextValue}>
          <BusinessProfileScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'business-config':
      return (
        <AppContext.Provider value={contextValue}>
          <BusinessConfigScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'coupons':
      return (
        <AppContext.Provider value={contextValue}>
          <CouponsScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'referrals':
      return (
        <AppContext.Provider value={contextValue}>
          <ReferralsScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'template-management':
      return (
        <AppContext.Provider value={contextValue}>
          <TemplateManagementScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'products':
    case 'products-list':
      return (
        <AppContext.Provider value={contextValue}>
          <ProductsListScreen
            catalogueId={currentProductParam || 'default'}
            scopedToDataListId={(routeParams as any)?.scopedToDataListId}
            scopedListName={(routeParams as any)?.scopedListName}
          />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'product-detail':
      return (
        <AppContext.Provider value={contextValue}>
          <ProductDetailScreen productId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'product-create':
      return (
        <AppContext.Provider value={contextValue}>
          <ProductCreateScreen catalogueId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'product-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <ProductEditScreen productId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'product-bulk-import':
      return (
        <AppContext.Provider value={contextValue}>
          <BulkImportScreen catalogueId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'product-scanner':
      return (
        <AppContext.Provider value={contextValue}>
          <ProductScannerScreen catalogueId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'lead-finder':
      return (
        <AppContext.Provider value={contextValue}>
          <LeadFinderScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'assignment-rules':
      return (
        <AppContext.Provider value={contextValue}>
          <AssignmentRulesScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'assignment-rule-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <AssignmentRuleEditScreen key={currentProductParam} ruleId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'lead-run':
      return (
        <AppContext.Provider value={contextValue}>
          <LeadRunScreen key={currentProductParam} runId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'data-lists':
      return (
        <AppContext.Provider value={contextValue}>
          <DataListsScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'data-list-schema-create':
      return (
        <AppContext.Provider value={contextValue}>
          <DataListSchemaScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'data-list-schema-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <DataListSchemaScreen listId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'data-list-records':
      return (
        <AppContext.Provider value={contextValue}>
          <DataListRecordsScreen listId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'data-list-record-create':
      return (
        <AppContext.Provider value={contextValue}>
          <DataListRecordFormScreen listId={(routeParams as any)?.listId} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'data-list-record-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <DataListRecordFormScreen listId={(routeParams as any)?.listId} recordId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'catalogues':
      return (
        <AppContext.Provider value={contextValue}>
          <CataloguesListScreen
            scopedToDataListId={(routeParams as any)?.scopedToDataListId}
            scopedListName={(routeParams as any)?.scopedListName}
          />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'catalogue-detail':
      return (
        <AppContext.Provider value={contextValue}>
          <CatalogueDetailScreen catalogueId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'catalogue-create':
      return (
        <AppContext.Provider value={contextValue}>
          <CatalogueCreateScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'vendors':
      return (
        <AppContext.Provider value={contextValue}>
          <VendorsListScreen
            scopedToDataListId={(routeParams as any)?.scopedToDataListId}
            scopedListName={(routeParams as any)?.scopedListName}
          />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'vendor-create':
      return (
        <AppContext.Provider value={contextValue}>
          <VendorFormScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'vendor-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <VendorFormScreen vendorId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'vendor-detail':
      return (
        <AppContext.Provider value={contextValue}>
          <VendorDetailScreen vendorId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'vendor-add-products':
      return (
        <AppContext.Provider value={contextValue}>
          <VendorAddProductsScreen vendorId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'vendor-bulk-upload':
      return (
        <AppContext.Provider value={contextValue}>
          <VendorBulkUploadScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'quotations':
      return (
        <AppContext.Provider value={contextValue}>
          <QuotationsListScreen
            scopedToDataListId={(routeParams as any)?.scopedToDataListId}
            scopedListName={(routeParams as any)?.scopedListName}
          />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'quotation-create':
      return (
        <AppContext.Provider value={contextValue}>
          <QuotationFormScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'quotation-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <QuotationFormScreen quotationId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'quotation-detail':
      return (
        <AppContext.Provider value={contextValue}>
          <QuotationDetailScreen quotationId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'quotation-templates':
      return (
        <AppContext.Provider value={contextValue}>
          <QuotationTemplatesListScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'quotation-template-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <QuotationTemplateEditorScreen templateId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'contact-create':
      return (
        <AppContext.Provider value={contextValue}>
          <ContactCreateScreen listId={(routeParams as any)?.listId} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'catalogue-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <CatalogueEditScreen catalogueId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'add-products-to-catalogue':
      return (
        <AppContext.Provider value={contextValue}>
          <AddProductsToCatalogueScreen catalogueId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'manage-catalogue-channels':
      return (
        <AppContext.Provider value={contextValue}>
          <ManageCatalogueChannelsScreen catalogueId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'quick-replies':
      return (
        <AppContext.Provider value={contextValue}>
          <QuickRepliesListScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'quick-reply-items':
      console.log('🎯 [AppNavigator] Rendering quick-reply-items screen');
      return (
        <AppContext.Provider value={contextValue}>
          <QuickReplyItemsListScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'quick-reply-set-detail':
      // Detail screen to be implemented in Part 2
      return (
        <AppContext.Provider value={contextValue}>
          <QuickRepliesListScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'quick-reply-set-create':
      return (
        <AppContext.Provider value={contextValue}>
          <QuickReplySetCreateScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'quick-reply-set-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <QuickReplySetEditScreen setId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'quick-reply-set-items':
      return (
        <AppContext.Provider value={contextValue}>
          <QuickReplySetItemsScreen setId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'quick-reply-item-create':
      return (
        <AppContext.Provider value={contextValue}>
          <QuickReplyItemCreateScreen setId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'quick-reply-item-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <QuickReplyItemEditScreen itemId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'dispatch-rules-list':
      return (
        <AppContext.Provider value={contextValue}>
          <DispatchRulesListScreen
            scope={(routeParams as any)?.scope}
            attachedTo={(routeParams as any)?.attachedTo}
            attachedToLabel={(routeParams as any)?.attachedToLabel}
          />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'dispatch-rule-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <DispatchRuleEditScreen
            ruleId={currentProductParam || undefined}
            scope={(routeParams as any)?.scope}
            attachedTo={(routeParams as any)?.attachedTo}
            attachedToLabel={(routeParams as any)?.attachedToLabel}
          />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'flows-list':
      return (
        <AppContext.Provider value={contextValue}>
          <FlowsListScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'flow-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <FlowEditScreen flowId={currentProductParam || undefined} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'calendars':
      return (
        <AppContext.Provider value={contextValue}>
          <CalendarListScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'calendar-create':
      return (
        <AppContext.Provider value={contextValue}>
          <CalendarCreateScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'calendar-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <CalendarEditScreen calendarId={currentProductParam || (contextValue.routeParams as any)?.calendarId} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'calendar-events':
      return (
        <AppContext.Provider value={contextValue}>
          <EventListScreen calendarId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'calendar-booking':
      return (
        <AppContext.Provider value={contextValue}>
          <CalendarBookingScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'product-view':
      return (
        <AppContext.Provider value={contextValue}>
          <CatalogViewScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'catalog-view':
      return (
        <AppContext.Provider value={contextValue}>
          <CatalogViewScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'cart':
      return (
        <AppContext.Provider value={contextValue}>
          <CartScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'checkout':
      return (
        <AppContext.Provider value={contextValue}>
          <CheckoutScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'order-success':
      return (
        <AppContext.Provider value={contextValue}>
          <OrderSuccessScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'track-order':
      return (
        <AppContext.Provider value={contextValue}>
          <TrackOrderScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'orders':
      return (
        <AppContext.Provider value={contextValue}>
          <OrdersScreen
            scopedToDataListId={(routeParams as any)?.scopedToDataListId}
            scopedListName={(routeParams as any)?.scopedListName}
          />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'order-add':
      return (
        <AppContext.Provider value={contextValue}>
          <AddOrderScreen mode="new" />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'order-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <AddOrderScreen mode="edit" orderId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'event-create':
      return (
        <AppContext.Provider value={contextValue}>
          <EventEditScreen calendarId={currentProductParam || (routeParams as any)?.calendarId} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'event-edit':
      return (
        <AppContext.Provider value={contextValue}>
          <EventEditScreen eventId={currentProductParam || (routeParams as any)?.eventId} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'event-detail':
      return (
        <AppContext.Provider value={contextValue}>
          <EventDetailScreen eventId={currentProductParam} />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    case 'business-calendar':
      return (
        <AppContext.Provider value={contextValue}>
          <BusinessCalendarScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );

    default:
      return (
        <AppContext.Provider value={contextValue}>
          <WelcomeScreen />
          {renderNotification()}
          {renderMobileCallOverlay()}
        </AppContext.Provider>
      );
  }
};

const styles = StyleSheet.create({
  rootNotificationContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 99999,
    elevation: 99999,
    pointerEvents: 'box-none',
    ...(Platform.OS === 'web' && {
      // Web-specific styles using CSS-in-JS
      position: 'fixed' as any,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 99999,
      pointerEvents: 'none',
    }),
    ...(Platform.OS !== 'web' && {
      // Mobile-specific styles - don't cover entire screen
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 'auto',
      height: 'auto',
      pointerEvents: 'box-none',
    }),
  },
  mobileCallOverlay: {
    position: 'fixed' as any,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 100000,
    backgroundColor: '#FFFFFF',
  },
  mobileCallMinimizedContainer: {
    position: 'fixed' as any,
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100000,
  },
  nativeCallModalContainer: { flex: 1, backgroundColor: '#000' },
  nativeCallWebView: { flex: 1 },
  nativeCallCloseButton: {
    position: 'absolute',
    top: 48,
    left: 16,
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: 'rgba(0,0,0,0.5)',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
